(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const applyHeight = (bar) => {
      const dismissed = bar.getAttribute('data-dismissed') === 'true';
      const h = dismissed ? 0 : Math.round(bar.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--site-ab-height', h + 'px');
    };
    document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
      if (bar.dataset.abInit) return;
      bar.dataset.abInit = '1';
      const key = 'ab-dismissed-' + (bar.id || 'default');
      if (sessionStorage.getItem(key) === '1') {
        bar.setAttribute('data-dismissed', 'true');
      }
      applyHeight(bar);
      window.addEventListener('resize', () => applyHeight(bar));
      bar.addEventListener('click', (e) => {
        if (e.target.closest('[data-announcement-close]')) {
          bar.setAttribute('data-dismissed', 'true');
          try { sessionStorage.setItem(key, '1'); } catch {}
          applyHeight(bar);
          window.dispatchEvent(new CustomEvent('announcement:dismissed'));
        }
      });
    });

    // ===== Countdown mode =====
    // data-ab-target accepts:
    //   "YYYY-MM-DD HH:MM"      (assumed Mexico City, UTC-6)
    //   "YYYY-MM-DDTHH:MM:SS±HH:MM" (full ISO; honoured as-is)
    // When the countdown hits 0 the parent announcement bar is dismissed
    // and --site-ab-height collapsed so the page reclaims the space.
    document.querySelectorAll('[data-ab-countdown]').forEach((el) => {
      if (el.dataset.cdInit) return;
      el.dataset.cdInit = '1';
      const raw = (el.getAttribute('data-ab-target') || '').trim();
      if (!raw) return;
      let iso = raw;
      // If no timezone is in the string, assume Mexico City (UTC-6).
      if (!/[zZ]|[+\-]\d\d:?\d\d$/.test(iso)) {
        iso = iso.replace(' ', 'T');
        if (!/T\d\d:\d\d:\d\d/.test(iso)) iso += ':00';
        iso += '-06:00';
      }
      const target = new Date(iso).getTime();
      if (Number.isNaN(target)) return;
      const hEl = el.querySelector('[data-ab-h]');
      const mEl = el.querySelector('[data-ab-m]');
      const sEl = el.querySelector('[data-ab-s]');
      const pad = (n) => String(n).padStart(2, '0');
      let timerId = 0;
      const tick = () => {
        const diff = target - Date.now();
        if (diff <= 0) {
          if (hEl) hEl.textContent = '00';
          if (mEl) mEl.textContent = '00';
          if (sEl) sEl.textContent = '00';
          const bar = el.closest('[data-announcement-bar]');
          if (bar) {
            bar.setAttribute('data-dismissed', 'true');
            document.documentElement.style.setProperty('--site-ab-height', '0px');
            window.dispatchEvent(new CustomEvent('announcement:dismissed'));
          }
          if (timerId) clearInterval(timerId);
          return;
        }
        // 3-cell layout (Horas / Minutos / Segundos). Hours roll up
        // beyond 24 so we never need a days cell.
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        const d = Math.floor(h / 24);
        // Buen Fin web 03-11: con más de un día, días en el contador.
        const dEl = el.querySelector('[data-ab-d]');
        const labs = el.querySelectorAll('[data-ab-l]');
        if (d > 0 && labs.length === 3) {
          const L = (el.getAttribute('data-ab-dhm') || 'Días|Horas|Minutos').split('|');
          if (hEl) hEl.textContent = pad(d);
          if (mEl) mEl.textContent = pad(h % 24);
          if (sEl) sEl.textContent = pad(m);
          labs.forEach((lab, i) => { lab.textContent = L[i]; });
          return;
        }
        if (labs.length === 3) {
          const L = (el.getAttribute('data-ab-hms') || 'Horas|Minutos|Segundos').split('|');
          labs.forEach((lab, i) => { lab.textContent = L[i]; });
        }
        if (dEl) dEl.textContent = d > 0 ? d + 'd ' : '';
        if (hEl) hEl.textContent = pad(dEl && d > 0 ? h % 24 : h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      };
      tick();
      timerId = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const drawers = document.querySelectorAll('[data-cart-drawer]');
    drawers.forEach((drawer) => {
      if (drawer.dataset.cdInit) return;
      drawer.dataset.cdInit = '1';

      const body = drawer.querySelector('[data-cd-body]');
      const panel = drawer.querySelector('[data-cd-panel]');

      const open = () => {
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        drawer.dispatchEvent(new CustomEvent('cd:open'));
      };
      const close = () => {
        // a11y: blur any focus inside the drawer BEFORE setting
        // aria-hidden, otherwise Chrome warns "Blocked aria-hidden
        // because descendant retained focus". Most common case is
        // pressing Esc / clicking trash → the close button or qty
        // button kept focus when the drawer hides.
        if (drawer.contains(document.activeElement) && document.activeElement.blur) {
          document.activeElement.blur();
        }
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        drawer.dispatchEvent(new CustomEvent('cd:close'));
      };

      const cartType = drawer.dataset.cartType || 'drawer';
      const autoOpen = drawer.dataset.autoOpen === 'true';

      // ─── /cart.js sessionStorage cache ─────────────────────────────
      // Avoids the 2-3s cold /cart.js fetch on tab restores + back/forward.
      // Cache TTL: 5 minutes. Invalidated on any /cart/add or /cart/change
      // by stamping the new cart in sessionStorage after each mutation.
      const CART_CACHE_KEY = 'cdCachedCart';
      const CART_CACHE_TTL_MS = 5 * 60 * 1000;
      const readCachedCart = () => {
        try {
          const raw = sessionStorage.getItem(CART_CACHE_KEY);
          if (!raw) return null;
          const { ts, cart } = JSON.parse(raw);
          if (Date.now() - ts > CART_CACHE_TTL_MS) return null;
          return cart;
        } catch (_) { return null; }
      };
      const writeCachedCart = (cart) => {
        if (!cart || typeof cart !== 'object') return;
        try {
          sessionStorage.setItem(CART_CACHE_KEY, JSON.stringify({ ts: Date.now(), cart }));
        } catch (_) {}
      };

      // Verbose debug logger — flip in console to trace cart events:
      //   window.__CART_DEBUG__ = true
      // Reload, then watch the console for [cart] entries showing:
      //   • click detected (line, current→next)
      //   • debounce timer set / coalesced / fired
      //   • network requests (which endpoints, with/without knownCart)
      //   • scroll preservation across innerHTML swap
      // Set to false to silence. Default off so production stays clean.
      const DBG = () => !!window.__CART_DEBUG__;
      // Wrap in IIFE-local read each time so flipping the flag at runtime
      // takes effect without page reload. Using property access (not const)
      // means even minified code can toggle live.
      Object.defineProperty(window, '__cartDebugStatus', {
        get: () => DBG() ? 'ON — see [cart] logs' : 'OFF (set window.__CART_DEBUG__ = true)',
        configurable: true,
      });

      // Global open/close API. When cart_type === 'page', clicks fall through
      // to the natural /cart link (no drawer). The auto-open after add-to-cart
      // is gated by data-auto-open; PDP code dispatches cart:open-drawer.
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-cart-drawer-open]');
        if (trigger) {
          if (cartType !== 'drawer') return; // let the link navigate to /cart
          e.preventDefault();
          open();
        }
      });
      drawer.addEventListener('click', (e) => {
        if (e.target.closest('[data-cd-close]')) {
          e.preventDefault();
          close();
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });
      window.addEventListener('cart:open-drawer', () => {
        if (cartType !== 'drawer' || !autoOpen) return;
        open();
      });
      // Manual force-open path (independent of auto_open setting)
      window.addEventListener('cart:open-drawer:force', () => {
        if (cartType === 'drawer') open();
      });

      // External add (PDP, custom widgets, etc.) — open drawer IMMEDIATELY
      // for instant feedback, then refresh body in the background. Awaiting
      // refresh before open meant ~300-500ms of nothing happening.
      //
      // event.detail can carry pre-fetched data:
      //   • sectionsHtml: HTML of the cart-drawer section (from POST
      //     /cart/add.js?sections=cart-drawer — same round-trip as add)
      //   • cartPromise:  in-flight /cart.js promise the dispatcher fired
      //     in parallel with the add
      // If both arrive, refresh() skips its own fetches entirely.
      window.addEventListener('cart:item-added', (e) => {
        const d = (e && e.detail) || {};
        const tr = d._trace || function () {};
        tr('cart-drawer received cart:item-added');
        if (cartType === 'drawer' && autoOpen) { open(); tr('drawer.open() invoked'); }
        else if (cartType === 'page') { window.location = '/cart'; return; }
        refresh({
          knownCart: null,
          knownCartPromise: d.cartPromise || null,
          knownSectionsHtml: d.sectionsHtml || null,
          _trace: tr,
        }).then(() => {
          tr('refresh() promise RESOLVED (paint pending)');
        });
      });

      // Optimistic skeleton row — dispatched by PDP/size-drawer right BEFORE
      // they POST /cart/add.js, so the user sees their product in the cart
      // INSTANTLY while the 1-2s server response is in flight. The morph in
      // refresh() wipes the pending row when the real HTML arrives (the
      // pending row has no data-cd-key, so morphChildrenByKey drops it
      // via parent.innerHTML='' and only re-appends the real keyed items).
      //
      // detail: { image, title, variantTitle, formattedPrice, _trace }
      const escapeHtml = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      })[c]);
      // Builds a pending <li.cd__item--pending> with the EXACT inner
      // structure of a real cart row (3-col qty grid + price + variant)
      // so CSS lays out the qty value centered between the two button
      // placeholders. Buttons are disabled stubs — they won't be clicked
      // before the morph replaces them with real ones ~1.3s later.
      const buildPendingItem = (d) => {
        const li = document.createElement('li');
        li.className = 'cd__item cd__item--pending';
        li.setAttribute('aria-busy', 'true');
        li.innerHTML = ''
          + '<div class="cd__item-media">'
          +   (d.image ? '<img class="cd__item-img" src="' + escapeHtml(d.image) + '" alt="" loading="eager" decoding="async">' : '')
          + '</div>'
          + '<div class="cd__item-info">'
          +   '<span class="cd__item-title">' + escapeHtml(d.title || '') + '</span>'
          +   (d.variantTitle
              ? '<div class="cd__item-variant-row"><p class="cd__item-size">' + escapeHtml(d.variantTitle) + '</p></div>'
              : '')
          +   '<div class="cd__item-qty-row">'
          +     '<div class="cd__item-qty">'
          +       '<button type="button" class="cd__qty-btn" disabled aria-hidden="true"></button>'
          +       '<span class="cd__qty-value">1</span>'
          +       '<button type="button" class="cd__qty-btn" disabled aria-hidden="true"></button>'
          +     '</div>'
          +     '<div class="cd__item-price"><span class="cd__item-price-now">' + escapeHtml(d.formattedPrice || '') + '</span></div>'
          +   '</div>'
          + '</div>';
        return li;
      };

      window.addEventListener('cart:optimistic-add', (e) => {
        const d = (e && e.detail) || {};
        const tr = d._trace || function () {};
        if (body.querySelector('.cd__item--pending')) { tr('optimistic skipped: already pending'); return; }
        if (body.querySelector('.cd__adding-overlay')) { tr('optimistic skipped: overlay already present'); return; }

        const itemsList = body.querySelector('.cd__items');
        if (itemsList) {
          // Non-empty cart: prepend skeleton row at TOP so the user
          // sees their addition immediately at eye-level. When the
          // morph lands, items re-render in Shopify's natural order
          // (usually new item at bottom). The brief visual shift is
          // acceptable — the alternative is showing it at the bottom
          // where the user may not see it without scrolling.
          const li = buildPendingItem(d);
          itemsList.insertBefore(li, itemsList.firstChild);
          // Scroll the items list to top so the new skeleton is visible
          // (in case the user had scrolled mid-list before).
          const scrollEl = body.querySelector('[data-cd-scroll]');
          if (scrollEl) scrollEl.scrollTop = 0;
          tr('optimistic row prepended to .cd__items (top)');
          const newCount = body.querySelectorAll('[data-cd-item], .cd__item--pending').length;
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            if (body.contains(el)) return;
            if (!el.classList.contains('site-header__cart-dot')) el.textContent = newCount;
            if (newCount > 0) el.removeAttribute('hidden');
          });
        } else {
          // Empty cart: server HTML has no shipping/upsell/footer (all
          // behind {% if count > 0 %}). Injecting a partial skeleton
          // looks half-baked. Solution: inject a centered loader card
          // that COVERS the empty state until the real HTML lands.
          const overlay = document.createElement('div');
          overlay.className = 'cd__adding-overlay';
          overlay.innerHTML = ''
            + '<div class="cd__adding-card">'
            +   (d.image ? '<img class="cd__adding-img" src="' + escapeHtml(d.image) + '" alt="" loading="eager">' : '')
            +   '<div class="cd__adding-info">'
            +     '<span class="cd__adding-spinner" aria-hidden="true"></span>'
            +     '<span class="cd__adding-label">' + (window.Shopify && Shopify.locale && Shopify.locale.indexOf('es') === 0 ? 'Añadiendo a tu carrito' : 'Adding to your cart') + '</span>'
            +     '<span class="cd__adding-title">' + escapeHtml(d.title || '') + '</span>'
            +     (d.variantTitle ? '<span class="cd__adding-variant">' + escapeHtml(d.variantTitle) + '</span>' : '')
            +   '</div>'
            + '</div>';
          body.appendChild(overlay);
          tr('optimistic empty-cart overlay injected');
        }
      });

      // Remove the empty-cart loading overlay once a refresh has applied
      // the real cart HTML. We hook into refresh's completion via a
      // MutationObserver on body: when .cd__items appears (or any
      // [data-cd-item]), the morph has happened — overlay can go.
      const overlayCleanupObserver = new MutationObserver(() => {
        if (body.querySelector('.cd__adding-overlay') && body.querySelector('[data-cd-item]')) {
          const ov = body.querySelector('.cd__adding-overlay');
          if (ov) ov.remove();
        }
      });
      overlayCleanupObserver.observe(body, { childList: true, subtree: true });

      // ─── Minimal DOM morph helpers ─────────────────────────────────
      // Replaces innerHTML swap so re-rendering the body after a cart
      // mutation doesn't destroy: <img> reload state, scroll position
      // inside the items list, focus, in-progress animations, and JS-
      // attached listeners on stable elements (shipping slider, etc.).
      //
      // Strategy:
      //   • Position-based child morph for most parents.
      //   • Key-based child morph when any new child has [data-cd-key]
      //     (cart line items use item.key — stable across re-renders).
      //   • Attribute morph preserves JS-set state attributes that the
      //     server doesn't know about (data-cd-slide-init, aria-busy).
      //
      // No external dependency (no morphdom). ~80 lines of code.
      const PRESERVE_ATTRS = new Set(['data-cd-slide-init', 'aria-busy']);

      const morphAttributes = (oldEl, newEl) => {
        const oldAttrs = oldEl.attributes;
        // Remove old attrs that aren't in new (skip preserved JS-state).
        for (let i = oldAttrs.length - 1; i >= 0; i--) {
          const name = oldAttrs[i].name;
          if (PRESERVE_ATTRS.has(name)) continue;
          if (!newEl.hasAttribute(name)) oldEl.removeAttribute(name);
        }
        // Add/update from new.
        const newAttrs = newEl.attributes;
        for (let i = 0; i < newAttrs.length; i++) {
          const attr = newAttrs[i];
          if (oldEl.getAttribute(attr.name) !== attr.value) {
            oldEl.setAttribute(attr.name, attr.value);
          }
        }
      };

      const morphNode = (oldNode, newNode) => {
        if (oldNode.nodeType !== newNode.nodeType || oldNode.nodeName !== newNode.nodeName) {
          oldNode.replaceWith(newNode.cloneNode(true));
          return;
        }
        if (oldNode.nodeType === Node.TEXT_NODE) {
          if (oldNode.nodeValue !== newNode.nodeValue) oldNode.nodeValue = newNode.nodeValue;
          return;
        }
        if (oldNode.nodeType === Node.COMMENT_NODE) return;
        morphElement(oldNode, newNode);
      };

      const morphChildrenByKey = (parent, oldChildren, newChildren) => {
        const oldByKey = new Map();
        oldChildren.forEach((c) => {
          if (c.nodeType === 1 && c.dataset && c.dataset.cdKey) oldByKey.set(c.dataset.cdKey, c);
        });
        const fragment = document.createDocumentFragment();
        newChildren.forEach((newChild) => {
          if (newChild.nodeType === 1 && newChild.dataset && newChild.dataset.cdKey) {
            const oldChild = oldByKey.get(newChild.dataset.cdKey);
            if (oldChild) {
              morphElement(oldChild, newChild);
              fragment.appendChild(oldChild);
              oldByKey.delete(newChild.dataset.cdKey);
            } else {
              fragment.appendChild(newChild.cloneNode(true));
            }
          } else {
            // Whitespace text nodes between keyed children — drop, the
            // fresh ones from newChildren cover them.
            if (newChild.nodeType === Node.TEXT_NODE && !newChild.nodeValue.trim()) {
              fragment.appendChild(newChild.cloneNode(true));
            } else if (newChild.nodeType === 1) {
              fragment.appendChild(newChild.cloneNode(true));
            }
          }
        });
        // Remaining old children (no matching key in new) → drop.
        // We don't need to remove them individually; replacing parent's
        // contents below does that.
        parent.innerHTML = '';
        parent.appendChild(fragment);
      };

      const morphChildren = (oldParent, newParent) => {
        const newChildren = Array.from(newParent.childNodes);
        const oldChildren = Array.from(oldParent.childNodes);
        const hasKeys = newChildren.some((n) => n.nodeType === 1 && n.dataset && n.dataset.cdKey);
        if (hasKeys) {
          morphChildrenByKey(oldParent, oldChildren, newChildren);
          return;
        }
        const max = Math.max(oldChildren.length, newChildren.length);
        for (let i = 0; i < max; i++) {
          const oldChild = oldChildren[i];
          const newChild = newChildren[i];
          if (oldChild && newChild) morphNode(oldChild, newChild);
          else if (newChild) oldParent.appendChild(newChild.cloneNode(true));
          else if (oldChild) oldChild.remove();
        }
      };

      const morphElement = (oldEl, newEl) => {
        // Preserve rows mid-collapse animation. Their inline styles
        // (max-height:0, opacity:0, padding:0...) must NOT be wiped by
        // morphAttributes, otherwise the row uncollapses visually for a
        // moment until the next morph cycle removes it. Symptom the
        // user sees: items reappear and then disappear after a batched
        // remove. Element stays in fragment, gets re-appended intact;
        // when server eventually processes its removal, the next morph
        // drops it (not in newChildren → not in fragment → wiped).
        if (oldEl.dataset && oldEl.dataset.cdRemoving === '1') return;
        morphAttributes(oldEl, newEl);
        morphChildren(oldEl, newEl);
      };

      // Render the cached empty state from <template data-cd-empty-template>
      // INSTANTLY into the drawer body. Used when cart becomes empty so
      // the user sees the empty state immediately, not after a 2-3s
      // server round-trip. Template was server-rendered on initial page
      // load with current settings + product recommendations.
      const renderEmptyStateFromTemplate = () => {
        const tpl = drawer.querySelector('template[data-cd-empty-template]');
        if (!tpl) return false;
        const scrollEl = body.querySelector('[data-cd-scroll]');
        if (!scrollEl) {
          // Edge case — no scroll wrapper. Append directly to body.
          body.appendChild(tpl.content.cloneNode(true));
          return true;
        }
        // Wipe items + replace with empty state content.
        scrollEl.innerHTML = '';
        scrollEl.appendChild(tpl.content.cloneNode(true));
        // Hide chrome that shouldn't show when cart is empty (shipping
        // bar, qty progress, footer with totals/checkout, upsell).
        body.querySelectorAll('.cd__shipping, .cd__qty-progress, .cd__upsell, .cd__foot').forEach(function (el) {
          el.style.display = 'none';
        });
        // Mark the wrapper as empty for any CSS that depends on it.
        const full = body.querySelector('[data-cd-full]');
        if (full) full.classList.add('cd__full--empty');
        return true;
      };

      // Refresh via Section Rendering API. Accepts an optional payload
      // with pre-fetched data to skip redundant fetches:
      //   • knownCart:         resolved cart object (from /cart/change.js)
      //   • knownCartPromise:  in-flight /cart.js promise (parallel kick-
      //                        off from PDP — we await it instead of
      //                        firing our own)
      //   • knownSectionsHtml: cart-drawer section HTML already fetched
      //                        (from POST /cart/add.js?sections=cart-drawer
      //                        — same round-trip as the add)
      // Calling pattern (back-compat):
      //   refresh()                 → fetch everything from scratch
      //   refresh(cartObj)          → cart known, fetch sections only
      //   refresh({knownCart, ...}) → object form for selective skips
      //
      // Preserves [data-cd-scroll] scrollTop across the innerHTML swap.
      // Without this, mutating a bottom line item snaps the drawer back to
      // top (the new .cd__scroll element starts at scrollTop=0).
      let refresh = async (arg) => {
        try {
          // Normalize arg to an options object so callers can pass either
          // a raw cart (legacy) or an options bag.
          const opts = (arg && typeof arg === 'object' && (
            'knownCart' in arg || 'knownCartPromise' in arg || 'knownSectionsHtml' in arg
          )) ? arg : { knownCart: arg };
          const knownCart = opts.knownCart || null;
          const knownCartPromise = opts.knownCartPromise || null;
          const knownSectionsHtml = opts.knownSectionsHtml || null;
          const tr = opts._trace || function () {};
          tr('refresh() ENTER', { knownCart: !!knownCart, knownCartPromise: !!knownCartPromise, knownSectionsHtml: !!knownSectionsHtml });
          if (DBG()) {
            const stack = new Error().stack;
            const callers = stack.split('\n').slice(2, 6).map(s => s.trim()).join(' ← ');
            console.log('%c[cart] refresh() ← ' + callers, 'color:#999;font-style:italic', {
              knownCart: !!knownCart, knownCartPromise: !!knownCartPromise, knownSectionsHtml: !!knownSectionsHtml
            });
          }
          const tStart = performance.now();

          // ─── FAST PATH: apply sectionsHtml IMMEDIATELY, defer cart.js ───
          // Renders drawer body without waiting for /cart.js (which can be
          // 2-3s on Shopify cold cache). User sees the new cart contents
          // instantly. Header bubble count is derived from the freshly-
          // swapped DOM (the cart-drawer-items snippet embeds the count
          // in data-cart-count + an item is rendered per line). The cart
          // JSON arrives later in the background and only dispatches
          // cart:updated for any chrome that needs full data.
          const applyHtml = (html) => {
            if (!html) return null;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            // Two possible shapes:
            //   (1) Full cart-drawer body — has [data-cd-body] wrapper
            //   (2) Minimal cart-items section — has [data-cart-items-section]
            //       wrapping a single <ul.cd__items>. Morph only the items
            //       list inside the existing drawer (preserves shipping,
            //       upsell, footer that don't re-render on each add).
            const newBody = doc.querySelector('[data-cd-body]');
            if (!newBody) return null;
            morphChildren(body, newBody);
            DBG() && console.log('%c[cart] morphed body (no innerHTML swap)', 'color:#3a3');
            // Derive count from the newly-rendered body so the header bubble
            // updates instantly, without waiting on /cart.js. The snippet
            // renders count in <span class="cd__count" data-cart-count>.
            const countEl = body.querySelector('[data-cart-count]');
            const count = countEl ? parseInt(countEl.textContent, 10) : null;
            if (count !== null && !isNaN(count)) {
              document.querySelectorAll('[data-cart-count]').forEach((el) => {
                if (body.contains(el)) return; // already in fresh DOM
                // The header cart-dot is a visual-only badge — never
                // write the count into its textContent (it should
                // stay empty); just toggle hidden based on > 0.
                if (!el.classList.contains('site-header__cart-dot')) {
                  el.textContent = count;
                }
                if (count > 0) el.removeAttribute('hidden');
                else if (
                  el.classList.contains('site-header__cart-dot') ||
                  el.classList.contains('site-header__cart-bubble')
                ) {
                  el.setAttribute('hidden', '');
                }
              });
              DBG() && console.log('%c[cart] header bubble updated from DOM count=' + count, 'color:#36c');
            }
            return { count };
          };

          // Decide section source. If supplied, apply NOW (synchronous).
          // Otherwise, fetch and apply when it lands.
          if (knownSectionsHtml) {
            DBG() && console.log('%c[cart] ✓ /?sections=cart-drawer SKIPPED (HTML applied IMMEDIATELY)', 'color:#3a3');
            tr('applyHtml START (sectionsHtml supplied)', { htmlLen: knownSectionsHtml.length });
            applyHtml(knownSectionsHtml);
            tr('applyHtml DONE (morph complete)');
          } else {
            DBG() && console.log('%c[cart] → /?sections=cart-drawer (fetched)', 'color:#c33');
            tr('fetch /?sections=cart-drawer SEND');
            const sectionsRes = await fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } });
            tr('sections RESPONSE');
            const data = await sectionsRes.json();
            tr('applyHtml START (post-fetch)');
            applyHtml(data['cart-drawer']);
            tr('applyHtml DONE');
          }

          // Cart object — only fetch if not already known. The result
          // dispatches cart:updated for any subscriber that needs full
          // data (e.g. external widgets). NOT blocking the body render.
          let cart = knownCart;
          if (!cart) {
            // Try sessionStorage cache first — avoids cold /cart.js on
            // tab restore + back/forward. Cache invalidated whenever the
            // cart changes (writeCachedCart on every change.js result).
            const cached = (!knownCartPromise) ? readCachedCart() : null;
            const cartFetchP = knownCartPromise
              || (cached ? Promise.resolve(cached) : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()));
            if (DBG()) {
              if (knownCartPromise) console.log('%c[cart] /cart.js REUSED (awaiting parallel promise, NON-BLOCKING)', 'color:#3a3');
              else if (cached) console.log('%c[cart] /cart.js HIT sessionStorage cache (skip network)', 'color:#3a3');
              else console.log('%c[cart] → /cart.js (fetched, NON-BLOCKING)', 'color:#c33');
            }
            cartFetchP
              .then((c) => {
                if (c && !cached) writeCachedCart(c);
                window.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
                DBG() && console.log('%c[cart] cart.js arrived, dispatched cart:updated', 'color:#999');
              })
              .catch((e) => console.error('[cart-drawer] cart.js failed', e));
            DBG() && console.log('%c[cart] refresh() done in ' + (performance.now() - tStart).toFixed(0) + 'ms (body painted; cart.js pending in BG)', 'color:#3a3;font-weight:bold');
            return null;
          }
          // knownCart provided — stamp it in cache so the NEXT cold start
          // skips the network entirely.
          writeCachedCart(cart);
          DBG() && console.log('%c[cart] ✓ /cart.js SKIPPED (knownCart reused, cached for next session)', 'color:#3a3');
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          DBG() && console.log('%c[cart] refresh() done in ' + (performance.now() - tStart).toFixed(0) + 'ms', 'color:#999');
          return cart;
        } catch (err) {
          console.error('[cart-drawer] refresh failed', err);
          return null;
        }
      };

      // Inline chrome update — applies the cart count + total from a known
      // cart response without re-rendering the body. Used between optimistic
      // UI updates and the background refresh so the bubble + total stay
      // accurate even before /?sections=cart-drawer lands.
      const applyCartChrome = (cart) => {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else if (el.closest('.site-header__cart-bubble')) el.setAttribute('hidden', '');
        });
      };

      // Format cents → currency string using the active shop currency.
      const money = (cents) => {
        try {
          return (cents / 100).toLocaleString(undefined, {
            style: 'currency',
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
          });
        } catch (e) { return (cents / 100).toFixed(2); }
      };

      // Inline body update — refresh visible line prices + drawer total from
      // a known cart response (e.g. /cart/change.js result). Avoids waiting
      // for /?sections=cart-drawer to land before the user sees the new
      // numbers. Bypassed if no items / no body.
      const applyCartBody = (cart) => {
        if (!cart || !cart.items) return;
        // Match by line key (stable) instead of line index (positional)
        // — when optimistically-removed rows are still in DOM with
        // cdRemoving + cdQty=0, server's idx N doesn't align with the
        // DOM row at data-line=N+1. Using key avoids the index drift.
        cart.items.forEach((item) => {
          if (!item.key) return;
          const row = body.querySelector('[data-cd-item][data-cd-key="' + CSS.escape(item.key) + '"]');
          if (!row) return;
          const priceNow = row.querySelector('.cd__item-price-now');
          if (priceNow) priceNow.textContent = money(item.final_line_price);
          const priceWas = row.querySelector('.cd__item-price-was');
          if (priceWas && item.original_line_price > item.final_line_price) {
            priceWas.textContent = money(item.original_line_price);
          }
        });
        const totalEl = drawer.querySelector('[data-cd-total]');
        if (totalEl) totalEl.textContent = money(cart.total_price);
      };

      // Returns { addJson, sectionsHtml, cartPromise } — bundled add so
      // refresh() can skip /?sections=cart-drawer and reuse the parallel
      // /cart.js promise. Used by upsell add buttons inside the drawer.
      const addVariant = async (id, qty) => {
        const res = await fetch('/cart/add.js?sections=cart-drawer&sections-url=/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: qty || 1 }),
        });
        if (!res.ok) throw new Error('add failed: ' + res.status);
        const addJson = await res.json();
        const sectionsHtml = addJson && addJson.sections && addJson.sections['cart-drawer'];
        const cartPromise = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        return { addJson, sectionsHtml: sectionsHtml || null, cartPromise };
      };
      // Bundled change: returns the cart object PLUS the freshly-rendered
      // cart-drawer section HTML in one round-trip. Caller can apply the
      // HTML directly via refresh({knownSectionsHtml,knownCart}) without
      // firing a separate /?sections=cart-drawer afterwards. Cuts post-
      // change qty refresh from 2 sequential round-trips to 1.
      //
      // Accepts EITHER a numeric positional line OR a line key. Shopify
      // MX rejects `id: <variant_id>:<hex>` line keys with 400 ("Invalid
      // id or line parameter"), so when given a key we MUST resolve it
      // to the current positional line by looking up the row in DOM.
      // After every change.js response the morph updates data-line on
      // remaining rows, so re-reading at fire-time gives a fresh index.
      const changeLine = async (lineOrKey, quantity) => {
        let resolvedLine = lineOrKey;
        const isKey = typeof lineOrKey === 'string' && /[^0-9]/.test(lineOrKey);
        if (isKey) {
          const row = body.querySelector('[data-cd-item][data-cd-key="' + CSS.escape(lineOrKey) + '"]');
          if (row && row.dataset.line) {
            resolvedLine = parseInt(row.dataset.line, 10);
          } else {
            // Row no longer in DOM (morph already removed it). Treat as
            // an already-processed delete — return a no-op resolved value
            // so the caller's success path runs cleanly. The current
            // cart state on server already reflects the desired qty.
            DBG() && console.log('%c[cart] changeLine SKIPPED — row not in DOM (already settled)', 'color:#f80', { lineOrKey });
            return { __skipped: true, items: [] };
          }
        }
        const bodyJson = { line: Number(resolvedLine), quantity: Number(quantity) };
        const res = await fetch('/cart/change.js?sections=cart-drawer&sections-url=/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(bodyJson),
        });
        if (!res.ok) {
          // Read the error body so we can see Shopify's complaint
          // ("Cart line not found", "Invalid id", etc).
          let errBody = '';
          try { errBody = await res.text(); } catch (e) {}
          console.error('[cart-drawer] change.js ' + res.status + ' →', bodyJson, '\nresponse:', errBody);
          throw new Error('change failed: ' + res.status + ' ' + errBody.slice(0, 200));
        }
        const json = await res.json();
        // /cart/change.js?sections returns the cart with a `sections` key.
        // Strip it so the rest of the code that uses `cart` treats it as
        // a plain cart object. Stash the HTML on a non-enumerable prop
        // so mutateLine can morph the body without re-fetching.
        const sectionsHtml = (json.sections && json.sections['cart-drawer']) || null;
        delete json.sections;
        Object.defineProperty(json, '__sectionsHtml', { value: sectionsHtml, enumerable: false });
        return json;
      };

      // Intercept ALL product-add forms on the page. Open the drawer
      // immediately on submit (instant feedback) and refresh once the add
      // completes — the body shows the previous state until refresh lands,
      // which is fine because the user is already focused on the drawer.
      document.addEventListener('submit', async (e) => {
        const form = e.target;
        if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        // Open immediately so the user sees the drawer slide in while the
        // add request is in flight.
        if (cartType === 'drawer' && autoOpen) open();
        try {
          // Bundled add: returns line + cart-drawer section HTML in one
          // round-trip. /cart.js fires in parallel for the full cart obj.
          const res = await fetch('/cart/add.js?sections=cart-drawer&sections-url=/', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          if (!res.ok) throw new Error('add failed: ' + res.status);
          const addJson = await res.json();
          const sectionsHtml = addJson && addJson.sections && addJson.sections['cart-drawer'];
          const cartPromise = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          await refresh({ knownSectionsHtml: sectionsHtml || null, knownCartPromise: cartPromise });
        } catch (err) {
          console.error('[cart-drawer] add intercept failed, falling back', err);
          form.submit();
        } finally {
          if (submitBtn) submitBtn.disabled = false;
        }
      });

      // Pessimistic per-row mutation. Shopify cart sessions briefly lock
      // between mutations, so we serialize: ONE in flight globally. Clicked
      // row gets .is-busy (spinner + dimmed); other rows' clicks are ignored
      // by the early bail. On response, morph replaces the row with fresh
      // server state (class auto-stripped). On error, .is-error shakes the
      // row for ~1.4s and unlocks.
      let mutationInFlight = false;
      const mutateLine = async (lineRef, nextQty, row) => {
        if (mutationInFlight) return;
        mutationInFlight = true;
        row.classList.add('is-busy');
        const t0 = performance.now();
        DBG() && console.log('%c[cart] mutate → qty=' + nextQty, 'color:#06c;font-weight:bold', { lineRef: String(lineRef).slice(0, 20) });
        try {
          const cart = await changeLine(lineRef, nextQty);
          DBG() && console.log('%c[cart] change.js ← ' + (performance.now() - t0).toFixed(0) + 'ms', 'color:#3a3', { item_count: cart && cart.item_count });
          writeCachedCart(cart);
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          if (cart.item_count === 0) {
            renderEmptyStateFromTemplate();
          } else {
            const html = cart.__sectionsHtml;
            if (html) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const newBody = doc.querySelector('[data-cd-body]');
              if (newBody) {
                morphChildren(body, newBody);
                const countEl = body.querySelector('[data-cart-count]');
                const count = countEl ? parseInt(countEl.textContent, 10) : null;
                if (count !== null && !isNaN(count)) {
                  document.querySelectorAll('[data-cart-count]').forEach((el) => {
                    if (body.contains(el)) return;
                    if (!el.classList.contains('site-header__cart-dot')) {
                      el.textContent = count;
                    }
                    if (count > 0) el.removeAttribute('hidden');
                    else if (
                      el.classList.contains('site-header__cart-dot') ||
                      el.classList.contains('site-header__cart-bubble')
                    ) {
                      el.setAttribute('hidden', '');
                    }
                  });
                }
              }
            }
          }
        } catch (err) {
          console.error('[cart-drawer] mutation failed', err);
          row.classList.remove('is-busy');
          row.classList.add('is-error');
          setTimeout(() => row.classList.remove('is-error'), 1400);
        } finally {
          mutationInFlight = false;
        }
      };

      // Qty +/- (delegated on body so re-rendered rows still work).
      // Pessimistic: row locks on click and unlocks when /cart/change.js
      // resolves. Trash icon renders on qty=1 in Liquid; minus on qty=1
      // sends qty=0 → server drops the line → morph removes the row.
      body.addEventListener('click', async (e) => {
        const qtyBtn = e.target.closest('[data-cd-qty]');
        if (qtyBtn) {
          e.preventDefault();
          const row = qtyBtn.closest('[data-cd-item]');
          if (!row) return;
          const lineRef = row.dataset.cdKey || row.dataset.line;
          const current = parseInt(row.dataset.cdQty, 10) || 1;
          const delta = qtyBtn.dataset.cdQty === 'plus' ? 1 : -1;
          const next = Math.max(0, current + delta);
          mutateLine(lineRef, next, row);
          return;
        }
        // Upsell add buttons — addVariant returns the line item, then we
        // refresh in background. Button disables briefly for tap feedback.
        const upsellBtn = e.target.closest('[data-cd-upsell-add]');
        if (upsellBtn) {
          e.preventDefault();
          const id = upsellBtn.dataset.cdUpsellAdd;
          upsellBtn.disabled = true;
          try {
            const { sectionsHtml, cartPromise } = await addVariant(id, 1);
            // Don't await refresh — it lands shortly and the user already
            // sees the click feedback. Pass bundled sectionsHtml + the
            // parallel /cart.js promise so refresh skips its own fetches.
            refresh({ knownSectionsHtml: sectionsHtml, knownCartPromise: cartPromise });
          } catch (err) { console.error(err); } finally { upsellBtn.disabled = false; }
          return;
        }
        // Discount toggle
        const discToggle = e.target.closest('[data-cd-discount-toggle]');
        if (discToggle) {
          e.preventDefault();
          const panel = body.querySelector('[data-cd-discount-panel]');
          if (panel) panel.hidden = !panel.hidden;
          return;
        }
        // Upsell arrows
        const prevArrow = e.target.closest('[data-cd-upsell-prev]');
        if (prevArrow) {
          const track = body.querySelector('[data-cd-upsell-track]');
          if (track) track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
          return;
        }
        const nextArrow = e.target.closest('[data-cd-upsell-next]');
        if (nextArrow) {
          const track = body.querySelector('[data-cd-upsell-track]');
          if (track) track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
          return;
        }
      });

      // Update header cart bubble/count when cart changes
      window.addEventListener('cart:updated', (e) => {
        const cart = e.detail || {};
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
          if (cart.item_count === 0 && el.closest('.site-header__cart-bubble')) el.setAttribute('hidden', '');
        });
      });

      // Order-now ETA renderer — fills the [data-cd-order-now-text] span
      // with the configured template, replacing %date% with a calculated
      // delivery date. Skips weekends optionally, shifts past cutoff to
      // the next day. Idempotent — safe to call after every refresh.
      const renderOrderNow = () => {
        const root = body.querySelector('[data-cd-order-now]');
        if (!root) return;
        const target = root.querySelector('[data-cd-order-now-text]');
        if (!target) return;
        const tmpl = root.dataset.template || 'order now and get it %date%';
        const proc = parseInt(root.dataset.processingDays, 10) || 0;
        const del = parseInt(root.dataset.deliveryDays, 10) || 0;
        const cutoff = parseInt(root.dataset.cutoffHour, 10) || 0;
        const skipWk = root.dataset.skipWeekends === '1';
        const now = new Date();
        let extra = 0;
        if (cutoff > 0 && now.getHours() >= cutoff) extra = 1;
        let target_date = new Date(now);
        target_date.setDate(target_date.getDate() + proc + del + extra);
        if (skipWk) {
          const day = target_date.getDay();
          if (day === 0) target_date.setDate(target_date.getDate() + 1);
          else if (day === 6) target_date.setDate(target_date.getDate() + 2);
        }
        const lang = (document.documentElement.lang || 'en').slice(0, 2);
        let formatted;
        try {
          formatted = target_date.toLocaleDateString(lang, { weekday: 'long', month: 'short', day: 'numeric' });
        } catch (e) {
          formatted = target_date.toDateString();
        }
        target.textContent = tmpl.replace('%date%', formatted);
      };
      renderOrderNow();
      drawer.addEventListener('cd:open', renderOrderNow);

      // Shipping banner slider (autoplay fade + dot sync). Re-init on every
      // re-render of [data-cd-body] (after cart mutations, refresh() replaces
      // innerHTML so the slider nodes are fresh).
      const initShippingSlider = () => {
        const slider = body.querySelector('[data-cd-slider]');
        if (!slider || slider.dataset.cdSlideInit) return;
        slider.dataset.cdSlideInit = '1';
        const track = slider.querySelector('[data-cd-slider-track]');
        const dotsHost = slider.querySelector('[data-cd-slider-dots]');
        const slides = track ? track.querySelectorAll('[data-cd-slide]') : [];
        if (!slides.length || slides.length < 2) return;
        const delay = Math.max(3, parseInt(slider.getAttribute('data-cd-autoplay'), 10) || 10) * 1000;
        let idx = 0;
        let timer = null;

        const show = (i) => {
          idx = ((i % slides.length) + slides.length) % slides.length;
          slides.forEach((s, k) => {
            const active = k === idx;
            s.classList.toggle('is-active', active);
            s.setAttribute('aria-current', active ? 'true' : 'false');
          });
          if (dotsHost) {
            dotsHost.querySelectorAll('[data-cd-dot]').forEach((d, k) => {
              d.setAttribute('aria-current', k === idx ? 'true' : 'false');
            });
          }
        };
        const next = () => show(idx + 1);
        const start = () => { stop(); timer = setInterval(next, delay); };
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

        if (dotsHost) {
          dotsHost.addEventListener('click', (e) => {
            const btn = e.target.closest && e.target.closest('[data-cd-dot]');
            if (!btn) return;
            const i = parseInt(btn.getAttribute('data-cd-dot'), 10) || 0;
            show(i); start();
          });
        }
        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);
        start();
      };
      initShippingSlider();
      drawer.addEventListener('cd:open', initShippingSlider);
      // Hook into refresh: after every replaceInnerHTML, re-init slider
      // AND re-render the ETA line so the date stays accurate after
      // cart mutations.
      const origRefresh = refresh;
      // eslint-disable-next-line no-func-assign
      refresh = async (...args) => {
        const r = await origRefresh(...args);
        initShippingSlider();
        renderOrderNow();
        return r;
      };
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clab-category-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cat-carousel]').forEach((root) => {
      const track = root.querySelector('[data-cc-track]');
      if (!track) return;
      let startX = 0, startLeft = 0, dragging = false, activePtr = null, suppressClick = false;
      const DRAG_THRESHOLD = 6;
      track.addEventListener('dragstart', (e) => e.preventDefault());
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        activePtr = e.pointerId;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        dragging = false;
        suppressClick = false;
      });
      track.addEventListener('pointermove', (e) => {
        if (e.pointerId !== activePtr) return;
        const dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) > DRAG_THRESHOLD) {
          dragging = true;
          root.classList.add('is-dragging');
          try { track.setPointerCapture(activePtr); } catch {}
        }
        if (dragging) {
          e.preventDefault();
          track.scrollLeft = startLeft - dx;
        }
      });
      const release = (e) => {
        if (e.pointerId !== activePtr) return;
        if (dragging) {
          try { track.releasePointerCapture(activePtr); } catch {}
          suppressClick = true;
          setTimeout(() => { suppressClick = false; root.classList.remove('is-dragging'); }, 50);
        }
        dragging = false;
        activePtr = null;
      };
      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('click', (e) => {
        if (suppressClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-image-filters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cif-row]').forEach((row) => {
      if (row.dataset.cifInit) return;
      row.dataset.cifInit = '1';
      let isDown = false, startX = 0, scrollLeft = 0, moved = 0;
      const DRAG_THRESHOLD = 6;
      row.addEventListener('mousedown', (e) => {
        isDown = true;
        moved = 0;
        startX = e.pageX - row.offsetLeft;
        scrollLeft = row.scrollLeft;
      });
      row.addEventListener('mouseleave', () => {
        if (!isDown) return;
        isDown = false;
        row.classList.remove('is-dragging');
      });
      row.addEventListener('mouseup', () => {
        isDown = false;
        row.classList.remove('is-dragging');
      });
      row.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const dx = (e.pageX - row.offsetLeft) - startX;
        moved = Math.abs(dx);
        if (moved > DRAG_THRESHOLD) {
          row.classList.add('is-dragging');
          e.preventDefault();
          row.scrollLeft = scrollLeft - dx * 1.5;
        }
      });
      row.addEventListener('click', (e) => {
        if (moved > DRAG_THRESHOLD) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tipo-filters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ctf-row]').forEach((row) => {
      if (row.dataset.ctfInit) return;
      row.dataset.ctfInit = '1';
      let isDown = false, startX = 0, scrollLeft = 0, moved = 0;
      const DRAG_THRESHOLD = 6;
      row.addEventListener('mousedown', (e) => {
        isDown = true;
        moved = 0;
        startX = e.pageX - row.offsetLeft;
        scrollLeft = row.scrollLeft;
      });
      row.addEventListener('mouseleave', () => {
        if (!isDown) return;
        isDown = false;
        row.classList.remove('is-dragging');
      });
      row.addEventListener('mouseup', () => {
        isDown = false;
        row.classList.remove('is-dragging');
      });
      row.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const dx = (e.pageX - row.offsetLeft) - startX;
        moved = Math.abs(dx);
        if (moved > DRAG_THRESHOLD) {
          row.classList.add('is-dragging');
          e.preventDefault();
          row.scrollLeft = scrollLeft - dx * 1.5;
        }
      });
      row.addEventListener('click', (e) => {
        if (moved > DRAG_THRESHOLD) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  })();

// Colección v3: cambiar de tipo sin recargar, como las pestañas de la portada
(function () {
  const nav = document.querySelector('.ctf3');
  const mainSec = document.querySelector('.shopify-section.section-main-collection');
  const tipoSec = nav && nav.closest('.shopify-section');
  if (!nav || !mainSec || !tipoSec) return;
  const mainId = mainSec.id.replace('shopify-section-', '');
  const tipoId = tipoSec.id.replace('shopify-section-', '');
  const cache = new Map();
  const conn = navigator.connection;
  const ahorro = conn && (conn.saveData || /2g/.test(conn.effectiveType || ''));
  let turno = 0;
  let enCurso = false;

  const clave = (u) => { const x = new URL(u, location.origin); return x.pathname + x.search; };
  const cargar = (u) => {
    const k = clave(u);
    if (cache.has(k)) return cache.get(k);
    const x = new URL(u, location.origin);
    x.searchParams.set('sections', tipoId + ',' + mainId);
    const p = fetch(x, { credentials: 'same-origin' })
      .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then((j) => {
        if (!j[mainId] || !j[tipoId]) throw new Error('sin secciones');
        return { main: j[mainId], tipo: j[tipoId] };
      });
    p.catch(() => cache.delete(k));
    cache.set(k, p);
    return p;
  };
  const parse = (h) => new DOMParser().parseFromString(h, 'text/html');

  const activar = (link) => nav.querySelectorAll('.ctf3__item').forEach((a) => a.classList.toggle('is-active', a === link));
  const copiarNav = (tipoHtml) => {
    const nuevos = parse(tipoHtml).querySelectorAll('.ctf3__item');
    const actuales = nav.querySelectorAll('.ctf3__item');
    if (nuevos.length !== actuales.length) return false;
    actuales.forEach((a, i) => {
      a.setAttribute('href', nuevos[i].getAttribute('href'));
      a.classList.toggle('is-active', nuevos[i].classList.contains('is-active'));
    });
    return true;
  };
  const pintar = (d) => {
    const doc = parse(d.main);
    const root = doc.getElementById(mainSec.id) || doc.body;
    root.querySelectorAll('.main-collection').forEach((el) => el.classList.add('js-loaded'));
    root.querySelectorAll('[data-mc-toolbar]').forEach((el) => el.removeAttribute('data-mc-init'));
    mainSec.innerHTML = root.innerHTML;
    if (window.__mcInitToolbars) window.__mcInitToolbars();
    return copiarNav(d.tipo);
  };
  const foto = () => ({ main: '<div id="' + mainSec.id + '">' + mainSec.innerHTML + '</div>', tipo: '<nav class="ctf3">' + nav.innerHTML + '</nav>' });
  const subir = () => {
    const top = nav.getBoundingClientRect().top;
    if (top < 0) window.scrollTo({ top: window.scrollY + top - 120 });
  };

  const ir = (url, conHistoria) => {
    const yo = ++turno;
    enCurso = true;
    const lento = setTimeout(() => { if (yo === turno) mainSec.classList.add('is-ctf-loading'); }, 120);
    return cargar(url).then((d) => {
      clearTimeout(lento);
      if (yo !== turno) return;
      enCurso = false;
      mainSec.classList.remove('is-ctf-loading');
      if (conHistoria) history.pushState({ ctf: 1 }, '', url);
      if (!pintar(d)) { location.href = url; return; }
      subir();
    }).catch(() => { location.href = url; });
  };

  nav.addEventListener('click', (e) => {
    const a = e.target.closest('.ctf3__item');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    const url = a.href;
    // Guarda lo que hay en pantalla, salvo si otro cambio sigue a medias
    if (!enCurso) {
      const f = Promise.resolve(foto());
      cache.set(clave(location.href), f);
      if (nav.querySelector('.ctf3__item').classList.contains('is-active')) cache.set(clave(nav.querySelector('.ctf3__item').href), f);
    }
    activar(a);
    ir(url, true);
  });
  window.addEventListener('popstate', () => ir(location.href, false));

  const prepararFotos = (d) => {
    parse(d.main).querySelectorAll('.main-collection__grid img').forEach((img, i) => {
      if (i > 3) return;
      const p = new Image();
      if (img.sizes) p.sizes = img.sizes;
      if (img.srcset) p.srcset = img.srcset;
      p.src = img.getAttribute('src');
    });
  };
  const adelantar = (a) => cargar(a.href).then(prepararFotos).catch(() => {});
  nav.querySelectorAll('.ctf3__item').forEach((a) => {
    a.addEventListener('pointerdown', () => adelantar(a), { passive: true });
  });
  if (!ahorro) {
    const pronto = () => nav.querySelectorAll('.ctf3__item:not(.is-active)').forEach(adelantar);
    const idle = () => (window.requestIdleCallback ? requestIdleCallback(pronto, { timeout: 3000 }) : setTimeout(pronto, 1500));
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.faqs').forEach((root) => {
      const items = root.querySelectorAll('.faqs__item');
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => { if (other !== item && other.open) other.open = false; });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(min-width: 768px)');

    document.querySelectorAll('[data-reass-slider]').forEach(function (slider) {
      if (slider.dataset.reassInit) return;
      slider.dataset.reassInit = '1';

      var track = slider.querySelector('[data-reass-track]');
      var dotsHost = slider.querySelector('[data-reass-dots]');
      if (!track || !dotsHost) return;

      var cells = track.children;
      if (cells.length < 2) return;

      var renderDots = function () {
        if (mq.matches) { dotsHost.innerHTML = ''; return; }
        var html = '';
        for (var i = 0; i < cells.length; i++) {
          html += '<button type="button" class="site-footer__reass-dot" data-reass-dot="' + i + '" aria-label="Slide ' + (i + 1) + '"' + (i === 0 ? ' aria-current="true"' : '') + '></button>';
        }
        dotsHost.innerHTML = html;
      };

      var updateActive = function () {
        if (mq.matches) return;
        var w = track.clientWidth;
        if (!w) return;
        var idx = Math.round(track.scrollLeft / w);
        dotsHost.querySelectorAll('.site-footer__reass-dot').forEach(function (d, i) {
          if (i === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      };

      renderDots();
      window.addEventListener('resize', renderDots);
      track.addEventListener('scroll', updateActive, { passive: true });

      dotsHost.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-reass-dot]');
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-reass-dot'), 10) || 0;
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      });
    });

    // Footer columns: open on desktop, closed on mobile (user toggles persist).
    var colMq = window.matchMedia('(min-width: 1024px)');
    var applyCols = function () {
      var isDesk = colMq.matches;
      document.querySelectorAll('[data-footer-col]').forEach(function (d) {
        if (d.dataset.footerColUser) return;
        if (isDesk) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
    };
    document.addEventListener('toggle', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-footer-col]')) {
        e.target.dataset.footerColUser = '1';
      }
    }, true);
    window.addEventListener('resize', applyCols);
    applyCols();

    // Currency / country switcher — submit the localization form on change.
    document.querySelectorAll('[data-footer-locale]').forEach(function (sel) {
      if (sel.dataset.localeInit) return;
      sel.dataset.localeInit = '1';
      sel.addEventListener('change', function () {
        if (sel.form) sel.form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const mode = header.dataset.stickyMode;           // off | always | scroll_up
    const transparentInit = header.dataset.transparentInit === 'true';
    const stickyThreshold = parseInt(header.dataset.stickyThreshold, 10) || 60;

    // Sticky-scrolled state: toggles bg/fg/height/logo when scrolled past threshold.
    // Independent of transparent mode — they can both be active (e.g. transparent
    // hero AND scrolled-down sticky bar).
    const updateStickyScrolled = () => {
      const past = window.scrollY > stickyThreshold;
      header.classList.toggle('is-sticky-scrolled', past);
    };

        // Altura "normal" del header (estado top-of-page) leída de las CSS vars,
    // para que el padding no dependa de la altura viva (sticky) del header.
    const normalHeaderHeight = () => {
      const isDesk = window.matchMedia('(min-width: 1024px)').matches;
      const raw = getComputedStyle(header).getPropertyValue(isDesk ? '--sh-height-desk' : '--sh-height-mob');
      const v = parseFloat(raw);
      return (isNaN(v) || v <= 0) ? header.offsetHeight : v;
    };

    // Body padding — FIJO por página. Nunca depende del scroll ni del estado
    // transparente/sólido. Cambiarlo al cruzar el threshold era lo que
    // desplazaba todo el contenido en la transición transparente → blanco.
    //  · Página con header transparente (home/men/women): solo la AB;
    //    el header sólido se superpone al contenido al scrollear.
    //  · Página normal: AB + altura normal del header, constante.
    const updatePad = () => {
      if (!header.classList.contains('is-fixed')) {
        document.body.style.paddingTop = '';
        document.documentElement.style.setProperty('--site-header-offset', '0px');
        return;
      }
      const abVar = getComputedStyle(document.documentElement).getPropertyValue('--site-ab-height').trim();
      const abH = parseFloat(abVar) || 0;

      if (transparentInit) {
        document.body.style.paddingTop = abH + 'px';
      } else {
        document.body.style.paddingTop = (normalHeaderHeight() + abH) + 'px';
      }

      const visible = !header.classList.contains('is-hidden');
      const offset = visible ? (header.offsetHeight + abH) : 0;
      document.documentElement.style.setProperty('--site-header-offset', offset + 'px');
    };

    const setSolid = () => {
      if (!header.classList.contains('is-transparent')) return;
      header.classList.remove('is-transparent');
      updatePad();
    };
    const setTransparent = () => {
      if (!transparentInit) return;
      if (header.classList.contains('is-transparent')) return;
      header.classList.add('is-transparent');
      updatePad();
    };

    if (mode === 'off') {
      return;
    }

    updatePad();
    window.addEventListener('resize', updatePad);
    window.addEventListener('announcement:dismissed', updatePad);

    let lastY = window.scrollY;
    const threshold = 8;
    // Forced-solid flags: when any of these is on, transparency is suppressed
    // until all are off and the scroll state re-allows it. Desktop only — we
    // don't flicker the mobile header on every icon tap.
    let hoverForce = false;
    let searchForce = false;
    const desktopMQ = window.matchMedia('(min-width: 1024px)');

    const applyTransparency = () => {
      const y = window.scrollY;
      const forced = (hoverForce || searchForce) && desktopMQ.matches;
      // Use the same threshold as is-sticky-scrolled so both classes flip in
      // a single onScroll tick. Otherwise (transparent off at 40, sticky on
      // at 60) the header crossfades twice in close succession, visible as a
      // double flicker on icons.
      if (y > stickyThreshold || forced) setSolid(); else setTransparent();
    };

    const onScroll = () => {
      const y = window.scrollY;
      applyTransparency();
      updateStickyScrolled();

      const wasHidden = header.classList.contains('is-hidden');
      if (mode === 'scroll_up') {
        const delta = y - lastY;
        if (y > 120 && delta > threshold) header.classList.add('is-hidden');
        else if (delta < -threshold) header.classList.remove('is-hidden');
      }
      const isHidden = header.classList.contains('is-hidden');
      if (wasHidden !== isHidden) {
        const abVar2 = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--site-ab-height')) || 0;
        const off = isHidden ? 0 : (header.offsetHeight + abVar2);
        document.documentElement.style.setProperty('--site-header-offset', off + 'px');
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // After the header's height crossfade settles (240ms), re-sync body
    // padding using the final offsetHeight — otherwise the padding can
    // get stuck at the pre-transition height, leaving a gap below the
    // sticky bar or pushing content down further than needed.
    header.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'height') updatePad();
    });

    // Desktop-only: hover on the header forces solid; leave reverts.
    header.addEventListener('mouseenter', () => {
      if (!desktopMQ.matches) return;
      hoverForce = true;
      applyTransparency();
    });
    header.addEventListener('mouseleave', () => {
      hoverForce = false;
      applyTransparency();
    });

    // Search modal open/close forces solid too (modal has white body; transparent
    // header over a modal backdrop looks broken).
    document.addEventListener('click', (e) => {
      const trigger = e.target && e.target.closest && e.target.closest('[data-search-modal-open]');
      if (trigger) { searchForce = true; applyTransparency(); }
      const closer = e.target && e.target.closest && e.target.closest('[data-search-modal-close]');
      if (closer) { searchForce = false; applyTransparency(); }
    }, true);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchForce) { searchForce = false; applyTransparency(); }
    });
    desktopMQ.addEventListener && desktopMQ.addEventListener('change', applyTransparency);

    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ig-pair]').forEach((wrap) => {
      if (wrap.dataset.igPairInit) return;
      wrap.dataset.igPairInit = '1';
      const track = wrap.querySelector('[data-ig-pair-track]');
      const dots  = wrap.querySelectorAll('.image-grid__pair-dot');
      if (!track || dots.length === 0) return;
      let ticking = false;
      const update = () => {
        const w = track.clientWidth;
        if (!w) { ticking = false; return; }
        const idx = Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        ticking = false;
      };
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.__mcInitToolbars = function () {
    document.querySelectorAll('[data-mc-toolbar]').forEach((toolbar) => {
      if (toolbar.dataset.mcInit) return;
      toolbar.dataset.mcInit = '1';

      const sortWrap = toolbar.querySelector('[data-mc-sort-wrap]');
      const sortBtn = toolbar.querySelector('[data-mc-sort-open]');
      const sortPop = toolbar.querySelector('[data-mc-sort-pop]');
      const filtersBtn = toolbar.querySelector('[data-mc-filters-open]');
      const facetsId = filtersBtn && filtersBtn.getAttribute('aria-controls');
      const facets = facetsId ? document.getElementById(facetsId) : null;

      // Sort popover toggle
      const closeSort = () => {
        if (!sortPop) return;
        sortPop.hidden = true;
        sortBtn && sortBtn.setAttribute('aria-expanded', 'false');
      };
      const openSort = () => {
        if (!sortPop) return;
        sortPop.hidden = false;
        sortBtn && sortBtn.setAttribute('aria-expanded', 'true');
      };
      if (sortBtn && sortPop) {
        sortBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (sortPop.hidden) openSort();
          else closeSort();
        });
        document.addEventListener('click', (e) => {
          if (!sortPop || sortPop.hidden) return;
          if (sortWrap && sortWrap.contains(e.target)) return;
          closeSort();
        });
      }

      // Facets dropdown — anchored to the bottom of the toolbar and the
      // left edge of the "Show filters" button. We expose two CSS vars
      // on the facets element so the panel slides to the right place
      // regardless of where the (sticky) toolbar currently sits.
      const positionFacets = () => {
        if (!facets || !toolbar || !filtersBtn) return;
        const tbRect = toolbar.getBoundingClientRect();
        const btnRect = filtersBtn.getBoundingClientRect();
        facets.style.setProperty('--mc-facets-top', tbRect.bottom + 'px');
        facets.style.setProperty('--mc-facets-left', btnRect.left + 'px');
      };
      let scrollListenerBound = false;
      const onScrollResize = () => positionFacets();
      const openFacets = () => {
        if (!facets) return;
        positionFacets();
        facets.setAttribute('aria-hidden', 'false');
        filtersBtn && filtersBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('mc-facets-open');
        if (!scrollListenerBound) {
          window.addEventListener('scroll', onScrollResize, { passive: true });
          window.addEventListener('resize', onScrollResize);
          scrollListenerBound = true;
        }
      };
      const closeFacets = () => {
        if (!facets) return;
        facets.setAttribute('aria-hidden', 'true');
        filtersBtn && filtersBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mc-facets-open');
        if (scrollListenerBound) {
          window.removeEventListener('scroll', onScrollResize);
          window.removeEventListener('resize', onScrollResize);
          scrollListenerBound = false;
        }
      };
      if (filtersBtn) {
        filtersBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (facets && facets.getAttribute('aria-hidden') === 'false') closeFacets();
          else openFacets();
        });
      }
      if (facets) {
        facets.querySelectorAll('[data-mc-facets-close]').forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            closeFacets();
          });
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (sortPop && !sortPop.hidden) closeSort();
        if (facets && facets.getAttribute('aria-hidden') === 'false') closeFacets();
      });
    });
    };
    window.__mcInitToolbars();

    // ====== Custom load-more — reveal hidden buffer in chunks ======
    // Belt-and-braces: the inline <script> after the section already adds
    // .js-loaded synchronously (so the hidden buffer collapses before
    // paint). This re-adds it in case a section is injected later (theme
    // editor), and reveals the Load More button + hides classic pagination.
    document.querySelectorAll('.main-collection').forEach((el) => {
      el.classList.add('js-loaded');
    });

    // Helpers ------------------------------------------------------------
    const visibleCount = (grid) =>
      grid.querySelectorAll(':scope > .product-card:not([data-mc-hidden])').length;
    const hiddenCards = (grid) =>
      grid.querySelectorAll(':scope > .product-card[data-mc-hidden]');

    const updateCounter = (btn, grid) => {
      const counter = btn.querySelector('[data-mc-load-more-counter]');
      if (!counter) return;
      const total = parseInt(btn.dataset.total, 10) || 0;
      counter.textContent = visibleCount(grid) + ' / ' + total;
    };

    // Fetch the next paginate-50 page and append ONLY its product cards
    // (kept hidden). Banners are intentionally dropped — they belong to
    // the first chunk only. Returns true if more cards were appended.
    const fetchNextInto = async (btn, grid) => {
      const url = btn.dataset.nextUrl;
      if (!url) return false;
      const res = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      const newGrid = doc.querySelector('.main-collection__grid');
      if (newGrid) {
        const frag = document.createDocumentFragment();
        newGrid.querySelectorAll(':scope > .product-card').forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('data-mc-hidden', '');
          frag.appendChild(clone);
        });
        grid.appendChild(frag);
      }

      // Advance the next-page pointer (blank when the fetched page was last).
      const nextBtn = doc.querySelector('[data-mc-load-more]');
      btn.dataset.nextUrl = (nextBtn && nextBtn.dataset.nextUrl) ? nextBtn.dataset.nextUrl : '';
      return true;
    };

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-mc-load-more]');
      if (!btn) return;
      e.preventDefault();
      if (btn.dataset.loading === '1') return;

      const grid = (btn.closest('.main-collection') || document).querySelector('.main-collection__grid');
      if (!grid) return;
      const step = parseInt(grid.dataset.mcRevealStep, 10) || 24;

      btn.dataset.loading = '1';
      btn.classList.add('is-loading');

      try {
        // Make sure we have at least `step` cards buffered before revealing
        // (fetch more 50-pages as needed; stop when no further page).
        while (hiddenCards(grid).length < step && btn.dataset.nextUrl) {
          await fetchNextInto(btn, grid);
        }

        // Reveal up to `step` hidden cards.
        const toReveal = Array.prototype.slice.call(hiddenCards(grid), 0, step);
        toReveal.forEach((card) => card.removeAttribute('data-mc-hidden'));

        updateCounter(btn, grid);

        // Nothing left to reveal and no further page → retire the button.
        if (hiddenCards(grid).length === 0 && !btn.dataset.nextUrl) {
          const wrap = btn.closest('[data-mc-load-more-wrap]');
          if (wrap) wrap.remove();
        }
      } catch (err) {
        console.error('[main-collection] Load more failed:', err);
        btn.classList.add('is-error');
      } finally {
        btn.dataset.loading = '0';
        btn.classList.remove('is-loading');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mx26"] && !Shopify.designMode) return;
  try {
    
  // Pill text rotator — swaps .is-active on a 3s interval so each
  // frame's slide+fade transition fires in turn. Width adaptation
  // is handled in CSS: inactive frames are position:absolute (don't
  // contribute to the rotator's intrinsic width), so the badge
  // resizes to whichever frame is currently active.
  (function () {
    function bootRotators() {
      document.querySelectorAll('.mp2__pill-rotator').forEach((rotator) => {
        if (rotator.dataset.rotatorInit) return;
        rotator.dataset.rotatorInit = '1';
        const frames = rotator.querySelectorAll('.mp2__pill-frame');
        if (frames.length < 2) {
          if (frames[0]) frames[0].classList.add('is-active');
          return;
        }
        let active = 0;
        frames[active].classList.add('is-active');
        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) return;
        setInterval(() => {
          frames[active].classList.remove('is-active');
          active = (active + 1) % frames.length;
          frames[active].classList.add('is-active');
        }, 3000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootRotators);
    } else {
      bootRotators();
    }
  })();

  // Mobile section reorder — on PDP we push two trust elements up
  // ahead of the spec table:
  //   1. pdp-ticker (benefits marquee) lands just BEFORE product-row
  //   2. product-row (which renders .pdp-brand-carousel) lands just
  //      BEFORE pdp-spec-duo
  // Net mobile order: main → pdp-ticker → product-row (brand
  // carousel) → pdp-spec-duo → rest. Idempotent + resize-aware so
  // the order flips back on desktop when the viewport crosses the
  // 1023px breakpoint.
  (function () {
    const MOBILE_MQ = window.matchMedia('(max-width: 1023px)');
    function placeBefore(node, anchor) {
      if (!node || !anchor) return;
      const isBeforeAnchor = !!(anchor.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_PRECEDING);
      if (MOBILE_MQ.matches) {
        if (!isBeforeAnchor) anchor.parentNode.insertBefore(node, anchor);
      } else if (isBeforeAnchor) {
        // Restore: drop node right after anchor (close enough to
        // the template's original DOM order without re-traversing
        // every sibling).
        if (anchor.nextSibling !== node) {
          anchor.parentNode.insertBefore(node, anchor.nextSibling);
        }
      }
    }
    function reorder() {
      // Only run when a PDP is on the page (.mp2 root sits inside
      // .shopify-section.section-main-product-v2).
      if (!document.querySelector('.mp2')) return;
      const productRow = document.querySelector('.shopify-section.section-product-row');
      const specDuo = document.querySelector('.shopify-section.section-pdp-spec-duo');
      const ticker = document.querySelector('.shopify-section.section-pdp-ticker');
      // Order matters: product-row must land before spec-duo FIRST,
      // then we can drop the ticker right before the (now-moved)
      // product-row.
      placeBefore(productRow, specDuo);
      placeBefore(ticker, productRow);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reorder);
    } else {
      reorder();
    }
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', reorder);
    else if (MOBILE_MQ.addListener) MOBILE_MQ.addListener(reorder);
  })();

  (function () {
    // Stock urgency tiers for the size selector. Assigns each in-stock
    // variant a tier (high / medium / low) using a deterministic random
    // seeded by (productId, variantId) plus a per-visitor salt held in
    // localStorage. Result is cached in localStorage so the same visitor
    // always sees the same tier across reloads — but two different
    // visitors will see different distributions, so it doesn't feel fake.
    // Tier copy: high → "En stock" (green); medium → "Pocas unidades"
    // (orange); low → "X unidades disponibles" with X random 1–4 (orange).
    // If the variant is genuinely sold out, Liquid already swapped the
    // label to the sold-out version; this JS skips those.
    const STOCK_VISITOR_SALT_KEY = 'pamp_stock_visitor_salt';
    const STOCK_TIER_KEY = (pid, vid) => `pamp_stock_${pid}_${vid}`;
    function getVisitorSalt() {
      try {
        let s = localStorage.getItem(STOCK_VISITOR_SALT_KEY);
        if (!s) {
          s = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
          localStorage.setItem(STOCK_VISITOR_SALT_KEY, s);
        }
        return s;
      } catch (e) { return 'fallback'; }
    }
    function hash01(str) {
      let h = 2166136261 >>> 0;
      for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619) >>> 0;
      }
      return (h >>> 0) / 4294967296;
    }
    function getStockTier(productId, variantId) {
      const cacheKey = STOCK_TIER_KEY(productId, variantId);
      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
        if (cached && cached.tier) return cached;
      } catch (e) {}
      const salt = getVisitorSalt();
      const seed = `${salt}|${productId}|${variantId}`;
      const r1 = hash01(seed);
      let tier, count = null;
      // Distribution: 55% high, 30% medium, 15% low.
      if (r1 < 0.55) tier = 'high';
      else if (r1 < 0.85) tier = 'medium';
      else {
        tier = 'low';
        const r2 = hash01(seed + '|count');
        count = 1 + Math.floor(r2 * 4); // 1..4
      }
      const out = { tier: tier, count: count };
      try { localStorage.setItem(cacheKey, JSON.stringify(out)); } catch (e) {}
      return out;
    }
    function applyStockTiers(root) {
      const productId = root.dataset.mp2ProductId;
      if (!productId) return;
      root.querySelectorAll('[data-mp2-stock-status]').forEach((el) => {
        const variantId = el.dataset.mp2VariantId;
        if (!variantId) return;
        const t = getStockTier(productId, variantId);
        el.setAttribute('data-mp2-stock-tier', t.tier);
        if (t.tier === 'high') {
          el.removeAttribute('data-mp2-stock-count');
          el.textContent = 'En stock';
        } else if (t.tier === 'medium') {
          el.removeAttribute('data-mp2-stock-count');
          el.textContent = 'Pocas unidades';
        } else {
          const c = t.count || 2;
          el.setAttribute('data-mp2-stock-count', String(c));
          el.textContent = c === 1
            ? '1 unidad disponible'
            : `${c} unidades disponibles`;
        }
      });
    }

    document.querySelectorAll('.mp2').forEach((root) => {
      // Stock urgency runs first so the size dialog is correct on open.
      applyStockTiers(root);
      const form = root.querySelector('[data-mp2-form]');
      if (!form) return;

      // Mobile sticky buy bar — two visible windows:
      //   (a) initial state: visible above the fold so the user has
      //       a one-tap path to the size popover before any scroll
      //   (b) post-CTA: reappears once the in-flow .mp2__cta-anchor
      //       has scrolled past the viewport top — nudges the user
      //       back to checkout after they've left the natural CTA
      //       behind.
      // While the user is reading the page (between first scroll and
      // passing the CTA) the bar disappears so it doesn't compete
      // with the in-flow CTA they're actively heading toward.
      // Click on the bar synthesises a click on [data-mp2-cta] so
      // the size popover opens directly (same funnel as the natural
      // CTA, no scroll detour). Desktop hides the bar via CSS.
      const mobileMQ = window.matchMedia('(max-width: 1023px)');
      const stickyBar = root.querySelector('[data-mp2-sticky-bar]');
      const stickyBarBtn = root.querySelector('[data-mp2-sticky-bar-trigger]');
      const inFlowCtaEl = root.querySelector('[data-mp2-cta]');
      const ctaAnchorEl = root.querySelector('.mp2__cta-anchor');
      let hasScrolled = false;
      const footerEl = document.querySelector('.shopify-section.section-footer, footer, .site-footer');
      const updateStickyBar = () => {
        if (!mobileMQ.matches) {
          root.classList.remove('is-sticky-bar-active');
          return;
        }
        // Ocultar si el footer ya entró en el viewport.
        if (footerEl) {
          const footerRect = footerEl.getBoundingClientRect();
          if (footerRect.top < window.innerHeight) {
            root.classList.remove('is-sticky-bar-active');
            return;
          }
        }
        // Mostrar solo cuando el CTA natural ya pasó por arriba del viewport.
        let shouldShow = false;
        if (ctaAnchorEl) {
          const ctaRect = ctaAnchorEl.getBoundingClientRect();
          shouldShow = ctaRect.bottom < 0;
        }
        root.classList.toggle('is-sticky-bar-active', shouldShow);
      };
      window.addEventListener('scroll', () => {
        hasScrolled = true;
        updateStickyBar();
      }, { passive: true });
      window.addEventListener('resize', updateStickyBar);
      mobileMQ.addEventListener && mobileMQ.addEventListener('change', updateStickyBar);
      updateStickyBar();
      if (stickyBarBtn) {
        stickyBarBtn.addEventListener('click', (e) => {
          // Delegate to the in-flow CTA so the existing handler
          // (open size popover OR add-to-cart, depending on whether
          // a size is already picked) runs end-to-end. Same anchor
          // for both buttons → identical funnel, no confusion.
          // stopPropagation prevents the document-level "click
          // outside the popover" handler defined below from firing
          // on the same tick and immediately closing the popover
          // that the synthesised CTA click just opened.
          e.preventDefault();
          e.stopPropagation();
          if (inFlowCtaEl) inFlowCtaEl.click();
        });
      }
      const variantInput = form.querySelector('[data-mp2-variant-id]');
      const colorBtns = root.querySelectorAll('[data-mp2-color]');
      const colorLabel = root.querySelector('[data-mp2-color-name]');
      const colorDot = root.querySelector('[data-mp2-color-dot]');
      const heightBtns = root.querySelectorAll('[data-mp2-height]');
      const heightLabel = root.querySelector('[data-mp2-height-name]');
      const cta = root.querySelector('[data-mp2-cta]');
      const popover = root.querySelector('[data-mp2-popover]');
      const popoverClose = root.querySelector('[data-mp2-popover-close]');
      const sizeBtns = root.querySelectorAll('[data-mp2-size]');

      // Variant resolution from option state — supports 2 or 3-option products
      // (Color + Size, or Color + Height + Size). Read once from JSON injected
      // by swatches_block; falls back to precomputed data-mp2-variant when
      // state is incomplete.
      const productDataNode = root.querySelector('[data-mp2-product-data]');
      let optionNames = [];
      let variantsList = [];
      if (productDataNode) {
        try {
          const parsed = JSON.parse(productDataNode.textContent || '{}');
          optionNames = parsed.options || [];
          variantsList = parsed.variants || [];
        } catch (_) {}
      }
      // Tokenise option name on word boundaries so localized variants
      // ("Talla (Mexico)", "Talla MX", "Color principal") match the key
      // lists. Exact match used to fail in MX where the option is named
      // "Talla (Mexico)" → sizeOptionName became undefined → optionState
      // never updated on size click → resolveVariant always returned the
      // INITIAL variant → every "Add to cart" sent the first variant ID.
      const findOption = (matches) => optionNames.find((n) => {
        const tokens = (n || '').trim().toLowerCase().split(/[\s\-_()]+/).filter(Boolean);
        return tokens.some((t) => matches.indexOf(t) !== -1);
      });
      const colorOptionName = findOption(['color', 'colour', 'couleur', 'farbe']);
      const heightOptionName = findOption(['height', 'altura', 'hauteur']);
      const sizeOptionName = findOption(['size', 'talla', 'taille', 'tamaño', 'tamanho', 'größe']);
      const initialId = variantInput ? variantInput.value : null;
      const initialVariant =
        variantsList.find((v) => String(v.id) === String(initialId)) || variantsList[0] || {};
      const optionState = {};
      optionNames.forEach((name, idx) => {
        optionState[name] = initialVariant['option' + (idx + 1)];
      });
      const resolveVariant = () => {
        if (!variantsList.length || !optionNames.length) return null;
        return variantsList.find((v) =>
          optionNames.every((n, i) => v['option' + (i + 1)] === optionState[n])
        );
      };
      // ----- Variant price display ------------------------------------
      // Parsed once. Map { variantId: { now: '€75,95', was: '€140,95'|null } }
      let mp2PriceMap = {};
      try {
        const _pn = root.querySelector('[data-mp2-variant-prices]');
        if (_pn) mp2PriceMap = JSON.parse(_pn.textContent || '{}') || {};
      } catch (e) { /* silent — prices just won't refresh */ }

      const priceWrapEl = root.querySelector('.mp2__price');
      const priceNowEl  = root.querySelector('.mp2__price-now');
      const saleTagEl   = root.querySelector('[data-mp2-sale-tag]');
      const priceSaveEl = root.querySelector('[data-mp2-price-save]');
      const savingsEl   = root.querySelector('[data-mp2-savings]');

      const updatePriceDisplay = (variantId) => {
        if (!variantId) return;
        const entry = mp2PriceMap[String(variantId)];
        if (!entry || !priceWrapEl || !priceNowEl) return;

        priceNowEl.textContent = entry.now;

        // .mp2__price-was is only present in markup when the INITIAL
        // variant was on sale. When switching to/from a sale variant we
        // need to inject or remove it so the campaign-styles :has() rule
        // and the strikethrough display stay consistent with reality.
        let priceWasEl = priceWrapEl.querySelector('.mp2__price-was');
        if (entry.was) {
          if (!priceWasEl) {
            priceWasEl = document.createElement('s');
            priceWasEl.className = 'mp2__price-was';
            priceWrapEl.insertBefore(priceWasEl, priceNowEl);
          }
          priceWasEl.textContent = entry.was;
          priceWrapEl.classList.add('is-on-sale');
        } else {
          if (priceWasEl) priceWasEl.remove();
          priceWrapEl.classList.remove('is-on-sale');
        }

        // Sale-tag ("Sale" red chip above the title) + savings line
        // ("Ahorra €X.XX") visibility — both ride the same on-sale
        // signal as the strikethrough above. `hidden` attribute keeps
        // them out of the layout when the active variant isn't on sale.
        if (saleTagEl) {
          if (entry.was) saleTagEl.removeAttribute('hidden');
          else saleTagEl.setAttribute('hidden', '');
          if (saleTagEl.dataset.cmpTag && entry.pct) saleTagEl.textContent = saleTagEl.dataset.cmpTag + ' -' + entry.pct + '%';
        }
        if (priceSaveEl) {
          if (entry.save) {
            priceSaveEl.removeAttribute('hidden');
            if (savingsEl) savingsEl.textContent = entry.save;
          } else {
            priceSaveEl.setAttribute('hidden', '');
          }
        }
      };

      const syncVariantInput = () => {
        const v = resolveVariant();
        if (v && variantInput) variantInput.value = v.id;
        if (v) updatePriceDisplay(v.id);
        return v;
      };

      // Paint the initial state — covers URLs that pre-select a variant.
      const _initialVariant = resolveVariant();
      if (_initialVariant) updatePriceDisplay(_initialVariant.id);
      const upsellTrack = root.querySelector('[data-mp2-upsell-track]');
      const upsellPrev = root.querySelector('[data-mp2-upsell-prev]');
      const upsellNext = root.querySelector('[data-mp2-upsell-next]');

      // Gallery dots tracking — activate the dot whose media is most in view,
      // and toggle is-gallery-active while the gallery column is visible.
      const dots = root.querySelectorAll('[data-mp2-dot]');
      const medias = root.querySelectorAll('[data-mp2-media]');
      const galleryEl = root.querySelector('[data-fig="85:6"]');
      if (dots.length && medias.length && 'IntersectionObserver' in window) {
        const setActive = (idx) => {
          dots.forEach((d) => d.classList.remove('is-active'));
          const active = root.querySelector('[data-mp2-dot="' + idx + '"]');
          if (active) active.classList.add('is-active');
        };
        const io = new IntersectionObserver((entries) => {
          let best = null, bestRatio = 0;
          entries.forEach((e) => {
            if (e.intersectionRatio > bestRatio) { best = e.target; bestRatio = e.intersectionRatio; }
          });
          if (best) setActive(best.getAttribute('data-mp2-media'));
        }, { threshold: [0.25, 0.5, 0.75, 1], rootMargin: '-30% 0px -30% 0px' });
        medias.forEach((m) => io.observe(m));
      }
      if (galleryEl && 'IntersectionObserver' in window) {
        const io2 = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            root.classList.toggle('is-gallery-active', e.isIntersecting);
          });
        }, { threshold: 0, rootMargin: '-20px 0px -20px 0px' });
        io2.observe(galleryEl);
      }

      // -----------------------------------------------------
      // Color filter — hide gallery medias whose img alt doesn't match the
      // active color. Matching is normalized: lowercase, accents stripped,
      // spaces → hyphens. Alt may contain extra text ("Negro / front view")
      // — substring match catches it. If NO media matches, show all (safe
      // fallback so a misconfigured product never renders an empty gallery).
      // -----------------------------------------------------
      const _deburrMap = { 'á':'a','é':'e','í':'i','ó':'o','ú':'u','ü':'u','ñ':'n','Á':'a','É':'e','Í':'i','Ó':'o','Ú':'u','Ü':'u','Ñ':'n' };
      const normalizeColor = (raw) => {
        if (!raw) return '';
        let s = String(raw).trim().replace(/^#?color[_-]/i, '').replace(/^#/, '');
        s = s.replace(/[áéíóúüñÁÉÍÓÚÜÑ]/g, (ch) => _deburrMap[ch] || ch);
        return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      };

      const getActiveColorValue = () => {
        const active = root.querySelector('[data-mp2-color].is-active');
        if (active) return active.getAttribute('data-mp2-color') || '';
        const checked = root.querySelector('input[type="radio"][name*="olor" i]:checked, input[type="radio"][name*="Color" i]:checked');
        if (checked && checked.value) return checked.value;
        const select = root.querySelector('select[name*="olor" i], select[name*="Color" i]');
        if (select && select.value) return select.value;
        const firstBtn = root.querySelector('[data-mp2-color]');
        return firstBtn ? (firstBtn.getAttribute('data-mp2-color') || '') : '';
      };

      const filterGalleryByColor = (rawColor) => {
        const cn = normalizeColor(rawColor);
        if (!medias.length) return;
        let matches = 0;
        let firstVisibleIdx = -1;
        medias.forEach((m, idx) => {
          const img = m.querySelector('img');
          const altNorm = normalizeColor(img && img.alt);
          // Match if alt contains the color word (handles "Negro - vista 1")
          const ok = !cn || (altNorm && (Array.prototype.some.call(medias, (mm) => { const ii = mm.querySelector('img'); return normalizeColor(ii && ii.alt) === cn; }) ? altNorm === cn : altNorm.indexOf(cn) !== -1));
          if (ok) {
            matches++;
            if (firstVisibleIdx < 0) firstVisibleIdx = idx;
          }
          m.classList.toggle('mp2__media--hidden', !ok);
        });
        if (matches === 0) {
          medias.forEach((m) => m.classList.remove('mp2__media--hidden'));
          firstVisibleIdx = 0;
        }
        // Sync the dots: hide ones whose media is filtered out, and mark
        // the first visible media's dot as active. Without this the dot
        // strip kept its full 6-dot count and the highlighted dot pointed
        // at a hidden image.
        dots.forEach((d) => {
          const dIdx = parseInt(d.getAttribute('data-mp2-dot'), 10);
          const m = medias[dIdx];
          const hidden = !!(m && m.classList.contains('mp2__media--hidden'));
          d.classList.toggle('mp2__dot--hidden', hidden);
          d.classList.toggle('is-active', dIdx === firstVisibleIdx);
        });
      };

      // Helper: paint the label text + dot from a swatch button's data.
      // Used by click (commit), mouseenter (hover preview) and
      // mouseleave (revert to the active swatch).
      const applyColorVisual = (colorVal, swatchStyle) => {
        if (colorLabel) colorLabel.textContent = colorVal ? colorVal.charAt(0).toUpperCase() + colorVal.slice(1).toLowerCase() : '';
        if (colorDot) {
          colorDot.setAttribute('title', colorVal);
          if (swatchStyle) colorDot.setAttribute('style', swatchStyle);
          else colorDot.removeAttribute('style');
        }
      };
      const restoreActiveColorVisual = () => {
        const active = root.querySelector('[data-mp2-color].is-active') || colorBtns[0];
        if (!active) return;
        applyColorVisual(
          active.getAttribute('data-mp2-color') || '',
          active.getAttribute('data-mp2-color-style') || ''
        );
      };

      // ─── Refresh the size list (availability + stock labels) when ──
      // the active color or height changes. Liquid renders the size
      // rows once with the INITIAL color/height combo; without this,
      // switching to a different color/height kept the OLD sold-out
      // states and stock-tier labels — sizes that should be sold out
      // showed "In stock" and vice versa.
      const refreshSizeAvailability = () => {
        const sizesList = root.querySelector('.mp2__sizes');
        if (!sizesList || !sizeOptionName || !variantsList.length) return;
        const inStockLabel = sizesList.dataset.mp2InStockLabel || 'In stock';
        const soldOutLabel = sizesList.dataset.mp2SoldOutLabel || 'Sold out';
        const notifyLabel = sizesList.dataset.mp2NotifyLabel || 'Notify me';

        sizeBtns.forEach((btn) => {
          const sizeVal = btn.getAttribute('data-mp2-size');
          const row = btn.closest('.mp2__size-row');
          if (!row || !sizeVal) return;
          // Find variant that matches: current color + current height + this size
          const v = variantsList.find((variant) =>
            optionNames.every((name, i) => {
              if (name === sizeOptionName) return variant['option' + (i + 1)] === sizeVal;
              return variant['option' + (i + 1)] === optionState[name];
            })
          );
          const available = !!(v && v.available);
          const vid = v ? v.id : '';
          // Update button state
          if (vid) btn.setAttribute('data-mp2-variant', vid);
          if (available) {
            row.classList.remove('is-unavailable');
            btn.disabled = false;
            btn.removeAttribute('aria-disabled');
          } else {
            row.classList.add('is-unavailable');
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          }
          // Wipe existing status + notify and rebuild for the new state.
          const oldStatus = row.querySelector('.mp2__size-status');
          if (oldStatus) oldStatus.remove();
          const oldNotify = row.querySelector('.mp2__size-notify');
          if (oldNotify) oldNotify.remove();
          if (available) {
            const statusEl = document.createElement('span');
            statusEl.className = 'mp2__size-status';
            statusEl.setAttribute('data-mp2-stock-status', '');
            statusEl.setAttribute('data-mp2-variant-id', String(vid));
            statusEl.textContent = inStockLabel;
            row.appendChild(statusEl);
          } else {
            const statusEl = document.createElement('span');
            statusEl.className = 'mp2__size-status mp2__size-status--out';
            statusEl.textContent = soldOutLabel;
            row.appendChild(statusEl);
            if (vid) {
              const notifyEl = document.createElement('a');
              notifyEl.className = 'mp2__size-notify';
              notifyEl.href = '#notify-' + vid;
              notifyEl.innerHTML = '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M4 11h6m-7.5-2h9L10 6.5V5a3 3 0 0 0-6 0v1.5L2.5 9z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + notifyLabel + '</span>';
              row.appendChild(notifyEl);
            }
          }
        });
        // Re-run the synthetic urgency tiers on the freshly-rebuilt
        // status spans (they now have the new variant ids).
        if (typeof applyStockTiers === 'function') applyStockTiers(root);
      };

      colorBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          colorBtns.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const colorVal = btn.getAttribute('data-mp2-color') || '';
          const swatchStyle = btn.getAttribute('data-mp2-color-style') || '';
          applyColorVisual(colorVal, swatchStyle);
          if (colorOptionName) optionState[colorOptionName] = colorVal;
          syncVariantInput();
          filterGalleryByColor(colorVal);
          refreshSizeAvailability();
        });
        // Hover preview: temporarily swap the label + dot to the
        // hovered swatch so the merchandiser sees "Negro y dorado /
        // Tecnología BOOSTHEIGHT™" as they point at different colors,
        // without committing the selection.
        btn.addEventListener('mouseenter', () => {
          applyColorVisual(
            btn.getAttribute('data-mp2-color') || '',
            btn.getAttribute('data-mp2-color-style') || ''
          );
        });
        btn.addEventListener('mouseleave', restoreActiveColorVisual);
      });

      // Same pattern as the color swatches: paint the height label
      // text from a pill's data-mp2-height. Used by click (commit),
      // mouseenter (hover preview) and mouseleave (revert).
      const applyHeightVisual = (heightVal) => {
        if (heightLabel) heightLabel.textContent = heightVal ? heightVal.charAt(0).toUpperCase() + heightVal.slice(1).toLowerCase() : '';
      };
      const restoreActiveHeightVisual = () => {
        const active = root.querySelector('[data-mp2-height].is-active') || heightBtns[0];
        if (!active) return;
        applyHeightVisual(active.getAttribute('data-mp2-height') || '');
      };

      heightBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          heightBtns.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const heightVal = btn.getAttribute('data-mp2-height') || '';
          applyHeightVisual(heightVal);
          // ── NUEVO: sincroniza el encabezado del popover "TALLA • +XCM"
          const popCurrent = root.querySelector('[data-mp2-size-current]');
          if (popCurrent) popCurrent.textContent = heightVal;
          // ─────────────────────────────────────────────────────────────
          if (heightOptionName) optionState[heightOptionName] = heightVal;
          syncVariantInput();
          refreshSizeAvailability();
        });
        // Hover preview — swap the "Altura / +XCM" label to whichever
        // pill the merchant is pointing at, then revert on leave.
        btn.addEventListener('mouseenter', () => {
          applyHeightVisual(btn.getAttribute('data-mp2-height') || '');
        });
        btn.addEventListener('mouseleave', restoreActiveHeightVisual);
      });

      // Initial filter on load — covers shop URLs that pre-select a color
      filterGalleryByColor(getActiveColorValue());

      // Cross-section: listen to native variant form changes too
      root.addEventListener('change', (e) => {
        const tgt = e.target;
        if (!tgt || !tgt.matches) return;
        if (tgt.matches('input[type="radio"][name*="olor" i], input[type="radio"][name*="Color" i], select[name*="olor" i], select[name*="Color" i]')) {
          filterGalleryByColor(tgt.value);
        }
      });

      // Popover open replaces the CTA (and Klarna text) in place on desktop
      // — the anchor gets is-popover-open and CSS hides the CTA/klarna so
      // the popover slides into the same row position. On mobile the same
      // class triggers a bottom-sheet treatment via CSS and the backdrop is
      // un-hidden so taps outside the sheet close it.
      const ctaAnchor = root.querySelector('.mp2__cta-anchor');
      const popoverBackdrop = root.querySelector('.mp2__popover-backdrop');
      function openPop() {
        if (popover) popover.hidden = false;
        if (popoverBackdrop) popoverBackdrop.hidden = false;
        if (ctaAnchor) ctaAnchor.classList.add('is-popover-open');
        document.body.classList.add('mp2-popover-open');
      }
      function closePop() {
        if (popover) popover.hidden = true;
        if (popoverBackdrop) popoverBackdrop.hidden = true;
        if (ctaAnchor) ctaAnchor.classList.remove('is-popover-open');
        document.body.classList.remove('mp2-popover-open');
      }

      async function ajaxAdd(variantId) {
        // Full-lifecycle trace — every phase logged with delta-ms since
        // the click. Pinpoints where time goes (network vs parse vs
        // render). Trace ID groups logs across phases in console.
        const T0 = performance.now();
        const traceId = Math.floor(Math.random() * 9999);
        const trace = (label, extra) => {
          const dt = (performance.now() - T0).toFixed(0);
          console.log('%c[ATC#' + traceId + '] +' + dt + 'ms %c' + label,
            'background:#f30;color:#fff;padding:1px 5px;font-weight:bold',
            'color:#f30;font-weight:bold', extra || '');
        };
        trace('ajaxAdd START', { variantId });
        try {
          if (variantId && variantInput) variantInput.value = variantId;
          const fd = new FormData(form);
          trace('fetch /cart/add.js?sections=cart-drawer SEND');
          const addP  = fetch('/cart/add.js?sections=cart-drawer&sections-url=/', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          const addRes = await addP;
          trace('add.js RESPONSE headers', { status: addRes.status, ok: addRes.ok });
          if (!addRes.ok) { const e = await addRes.json().catch(() => ({})); throw new Error(e.description || 'add failed'); }
          const addJson = await addRes.json();
          trace('add.js BODY parsed', { hasSections: !!(addJson && addJson.sections), htmlLen: addJson && addJson.sections && addJson.sections['cart-drawer'] ? addJson.sections['cart-drawer'].length : 0 });
          const sectionsHtml = addJson && addJson.sections && addJson.sections['cart-drawer'];
          trace('fetch /cart.js SEND (parallel)');
          const cartP = fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then((r) => { trace('cart.js RESPONSE headers', { status: r.status }); return r.json(); })
            .then((c) => { trace('cart.js BODY parsed', { itemCount: c && c.item_count }); return c; });
          // Embed trace fn in the event so cart-drawer can log into the
          // same lifecycle and we see the full picture in one console group.
          window.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { sectionsHtml: sectionsHtml || null, cartPromise: cartP, _trace: trace }
          }));
          trace('cart:item-added DISPATCHED');
        } catch (err) { trace('ERROR', err && err.message); console.error(err); form.submit(); }
      }

      if (cta) {
        cta.addEventListener('click', async (e) => {
          e.preventDefault();
          if (popover) { if (popover.hidden) openPop(); else closePop(); }
          else {
            // Single-variant product (no popover) — open drawer immediately
            // for instant feedback while /cart/add.js resolves in BG.
            window.dispatchEvent(new CustomEvent('cart:open-drawer:force'));
            await ajaxAdd();
          }
        });
      }
      if (popoverClose) popoverClose.addEventListener('click', closePop);
      document.addEventListener('click', (e) => {
        if (!popover || popover.hidden) return;
        // Don't close on clicks INSIDE the popover, on the in-flow
        // CTA, or on the sticky-bar trigger (which delegates to the
        // CTA and would otherwise be flagged as an outside click).
        if (popover.contains(e.target)) return;
        if (cta && cta.contains(e.target)) return;
        if (stickyBarBtn && stickyBarBtn.contains(e.target)) return;
        closePop();
      });

      sizeBtns.forEach((btn) => {
        btn.addEventListener('click', async () => {
          if (btn.disabled) return;
          const sizeVal = btn.getAttribute('data-mp2-size') || '';
          if (sizeOptionName) optionState[sizeOptionName] = sizeVal;
          const resolved = syncVariantInput();
          // Prefer resolveVariant() result so the COLOR (and height)
          // currently picked by the user is honoured — the button's
          // data-mp2-variant attribute is baked at render time from the
          // initial color, so it ignores any color change made after
          // load. resolved.id reflects the full current optionState
          // (now correct since findOption tokenises localized names
          // like "Talla (Mexico)"). Fallback to the btn attr only if
          // no variant matches the state (e.g. invalid combo).
          const vid = (resolved && resolved.id) || btn.getAttribute('data-mp2-variant');
          closePop();
          // Loading state — once popover is closed the CTA re-appears,
          // we immediately switch it to the spinner so the user doesn't
          // see "ELIGE TU TALLA" flash back before the cart opens.
          if (cta) cta.classList.add('is-loading');
          // Open the cart drawer IMMEDIATELY so the user sees instant
          // feedback (existing cart contents) instead of staring at the
          // PDP for ~2-3s while /cart/add.js resolves. When the add lands,
          // the new item appears in the body via cart:item-added → refresh.
          window.dispatchEvent(new CustomEvent('cart:open-drawer:force'));
          // Inject an optimistic skeleton row into the cart drawer so the
          // user sees THEIR product in the cart NOW, not 1.3s from now
          // when add.js returns. Morph replaces it with the real row when
          // the server response arrives. Resolves variant data from the
          // parsed product JSON so the image/title/variant/price match
          // what the server will eventually render.
          const optimisticVariant = variantsList.find(function (v) { return String(v.id) === String(vid); });
          if (optimisticVariant) {
            const pTitleEl = root.querySelector('.mp2__title');
            const pNowEl = root.querySelector('.mp2__price-now');
            window.dispatchEvent(new CustomEvent('cart:optimistic-add', {
              detail: {
                variantId: vid,
                image: (optimisticVariant.featured_image && optimisticVariant.featured_image.src)
                  || (optimisticVariant.featured_media && optimisticVariant.featured_media.preview_image && optimisticVariant.featured_media.preview_image.src)
                  || null,
                title: pTitleEl ? pTitleEl.textContent.trim() : '',
                variantTitle: optimisticVariant.public_title || optimisticVariant.title || '',
                formattedPrice: pNowEl ? pNowEl.textContent.trim() : '',
              }
            }));
          }
          try {
            await ajaxAdd(vid);
          } finally {
            // ajaxAdd fires cart:item-added → cart drawer opens at the
            // same instant the fetch resolves. Drop the spinner now so
            // the CTA quietly returns to normal underneath the open
            // drawer (visible again if the user closes the drawer).
            if (cta) cta.classList.remove('is-loading');
          }
        });
      });

      // Expand the click target to the entire .mp2__size-row so the
      // user can tap anywhere on the row (status label, empty space)
      // and not just the underlined number. The "Notify me" anchor on
      // sold-out variants is excluded so its own navigation still
      // works, and is-unavailable rows are skipped entirely.
      root.querySelectorAll('.mp2__size-row').forEach((row) => {
        if (row.classList.contains('is-unavailable')) return;
        row.addEventListener('click', (e) => {
          if (e.target.closest('.mp2__size-notify, [data-mp2-size]')) return;
          const inner = row.querySelector('[data-mp2-size]');
          if (inner && !inner.disabled) inner.click();
        });
      });

      // Upsell pairs-well-with scroll
      if (upsellTrack) {
        const step = () => upsellTrack.clientWidth * 0.92;
        if (upsellPrev) upsellPrev.addEventListener('click', () => upsellTrack.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (upsellNext) upsellNext.addEventListener('click', () => upsellTrack.scrollBy({ left: step(), behavior: 'smooth' }));
      }

      // Upsell card CTA = AJAX add its variant
      root.querySelectorAll('[data-mp2-upsell-buy]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const vid = btn.getAttribute('data-mp2-upsell-buy');
          await ajaxAdd(vid);
        });
      });

      // Accordion drawer — opened by drawer_block links + Size Guide chip
      const drawerEl = root.querySelector('[data-mp2-drawer]');
      const drawerTitle = root.querySelector('[data-mp2-drawer-title]');
      const drawerBody = drawerEl ? drawerEl.querySelector('.mp2-drawer__body') : null;
      const drawerPanel = drawerEl ? drawerEl.querySelector('.mp2-drawer__panel') : null;
      let drawerPrevFocus = null;

      const openDrawer = (slot, label) => {
        if (!drawerEl) return;
        drawerPrevFocus = document.activeElement;
        drawerEl.hidden = false;
        drawerEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => drawerEl.setAttribute('data-mp2-drawer-open', ''));
        document.body.classList.add('mp2-drawer-open');
        if (drawerTitle) drawerTitle.textContent = label || '';
        drawerEl.querySelectorAll('.mp2-drawer__section').forEach((s) => {
          s.open = s.getAttribute('data-mp2-drawer-slot') === slot;
        });
        const target = slot && drawerEl.querySelector('[data-mp2-drawer-slot="' + slot + '"]');
        if (target && drawerBody) {
          setTimeout(() => { drawerBody.scrollTop = Math.max(0, target.offsetTop - 8); }, 50);
        }
        if (drawerPanel) setTimeout(() => drawerPanel.focus({ preventScroll: true }), 360);
      };
      const closeDrawer = () => {
        if (!drawerEl) return;
        drawerEl.removeAttribute('data-mp2-drawer-open');
        drawerEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-drawer-open');
        setTimeout(() => { drawerEl.hidden = true; }, 350);
        if (drawerPrevFocus && typeof drawerPrevFocus.focus === 'function') drawerPrevFocus.focus({ preventScroll: true });
      };

      root.querySelectorAll('[data-mp2-drawer-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.getAttribute('data-mp2-drawer-empty') === 'true') return;
          const slot = btn.getAttribute('data-mp2-drawer-open');
          const label = btn.textContent.trim();
          openDrawer(slot, label);
        });
      });
      if (drawerEl) {
        drawerEl.querySelectorAll('[data-mp2-drawer-close]').forEach((el) => el.addEventListener('click', closeDrawer));
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && drawerEl.hasAttribute('data-mp2-drawer-open')) closeDrawer();
        });
      }

      // Tech detail drawer (Figma 801:1121) — open from marketing "see more" button
      const techEl = root.querySelector('[data-mp2-tech-drawer]');
      let techPrevFocus = null;
      const openTech = () => {
        if (!techEl) return;
        techPrevFocus = document.activeElement;
        techEl.hidden = false;
        techEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => techEl.setAttribute('data-mp2-tech-drawer-open', ''));
        document.body.classList.add('mp2-tech-open');
      };
      const closeTech = () => {
        if (!techEl) return;
        techEl.removeAttribute('data-mp2-tech-drawer-open');
        techEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-tech-open');
        setTimeout(() => { techEl.hidden = true; }, 360);
        if (techPrevFocus && typeof techPrevFocus.focus === 'function') techPrevFocus.focus({ preventScroll: true });
      };
      root.querySelectorAll('[data-mp2-tech-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openTech();
        });
      });
      if (techEl) {
        techEl.querySelectorAll('[data-mp2-tech-close]').forEach((el) => el.addEventListener('click', closeTech));
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && techEl.hasAttribute('data-mp2-tech-drawer-open')) closeTech();
        });
      }

      // Story lightbox — vertical video popup
      const lightboxEl = root.querySelector('[data-mp2-lightbox]');
      const lightboxSlides = lightboxEl ? Array.from(lightboxEl.querySelectorAll('[data-mp2-story-slide]')) : [];
      const lightboxPrev = lightboxEl ? lightboxEl.querySelector('[data-mp2-story-prev]') : null;
      const lightboxNext = lightboxEl ? lightboxEl.querySelector('[data-mp2-story-next]') : null;
      let lightboxIdx = 0;
      let lightboxPrevFocus = null;

      const pauseAllLightboxVideos = () => {
        lightboxSlides.forEach((s) => {
          const v = s.querySelector('video');
          if (v) { try { v.pause(); v.currentTime = 0; } catch (_) {} }
        });
      };
      const showLightboxSlide = (idx) => {
        if (!lightboxSlides.length) return;
        if (idx < 0) idx = lightboxSlides.length - 1;
        if (idx >= lightboxSlides.length) idx = 0;
        lightboxIdx = idx;
        pauseAllLightboxVideos();
        lightboxSlides.forEach((s, i) => { s.hidden = i !== idx; });
        const current = lightboxSlides[idx];
        const v = current && current.querySelector('video');
        if (v) { v.muted = false; v.play().catch(() => { v.muted = true; v.play().catch(() => {}); }); }
      };
      const openLightbox = (idx) => {
        if (!lightboxEl) return;
        lightboxPrevFocus = document.activeElement;
        lightboxEl.hidden = false;
        lightboxEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => lightboxEl.setAttribute('data-mp2-lightbox-open', ''));
        document.body.classList.add('mp2-lightbox-open');
        showLightboxSlide(idx);
      };
      const closeLightbox = () => {
        if (!lightboxEl) return;
        pauseAllLightboxVideos();
        lightboxEl.removeAttribute('data-mp2-lightbox-open');
        lightboxEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-lightbox-open');
        setTimeout(() => { lightboxEl.hidden = true; }, 260);
        if (lightboxPrevFocus && typeof lightboxPrevFocus.focus === 'function') lightboxPrevFocus.focus({ preventScroll: true });
      };

      root.querySelectorAll('[data-mp2-story-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = parseInt(btn.getAttribute('data-mp2-story-open'), 10) || 0;
          openLightbox(idx);
        });
      });
      if (lightboxEl) {
        lightboxEl.querySelectorAll('[data-mp2-lightbox-close]').forEach((el) => el.addEventListener('click', closeLightbox));
        if (lightboxPrev) lightboxPrev.addEventListener('click', () => showLightboxSlide(lightboxIdx - 1));
        if (lightboxNext) lightboxNext.addEventListener('click', () => showLightboxSlide(lightboxIdx + 1));
        document.addEventListener('keydown', (e) => {
          if (!lightboxEl.hasAttribute('data-mp2-lightbox-open')) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') showLightboxSlide(lightboxIdx - 1);
          if (e.key === 'ArrowRight') showLightboxSlide(lightboxIdx + 1);
        });
      }

      // Layered sticky stack — cumulative top offsets on desktop.
      // Layer 1 docks against the live --site-header-offset; layers 2/3 use
      // calc() referencing --site-header-offset so they re-evaluate live as
      // the header offset changes (sticky scroll, AB dismissed, hidden).
      // Static numeric values would freeze the offset to whatever the header
      // measured at section init.
      const stackLayer1 = root.querySelector('[data-mp2-layer="1"]');
      const stackLayer2 = root.querySelector('[data-mp2-layer="2"]');
      const stackLayer3 = root.querySelector('[data-mp2-layer="3"]');
      if (stackLayer1 || stackLayer2 || stackLayer3) {
        const computeStack = () => {
          const stickyFallbackStr = getComputedStyle(root).getPropertyValue('--mp2-sticky-top').trim();
          const stickyFallback = parseInt(stickyFallbackStr, 10) || 80;
          const h1 = stackLayer1 ? stackLayer1.offsetHeight : 0;
          const h2 = stackLayer2 ? stackLayer2.offsetHeight : 0;
          // Layer 1: clear any stale --mp2-layer-top so the CSS fallback
          // chain top: var(--mp2-layer-top, var(--site-header-offset, …))
          // resolves directly to --site-header-offset.
          if (stackLayer1) stackLayer1.style.removeProperty('--mp2-layer-top');
          if (stackLayer2) stackLayer2.style.setProperty('--mp2-layer-top', `calc(var(--site-header-offset, ${stickyFallback}px) + ${h1}px)`);
          if (stackLayer3) stackLayer3.style.setProperty('--mp2-layer-top', `calc(var(--site-header-offset, ${stickyFallback}px) + ${h1 + h2}px)`);
        };
        computeStack();
        window.addEventListener('resize', computeStack);
        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(computeStack);
          if (stackLayer1) ro.observe(stackLayer1);
          if (stackLayer2) ro.observe(stackLayer2);
        }
      }

      // Colors popup — bottom sheet triggered on mobile from swatches block
      const colorsPopup = root.querySelector('[data-mp2-colors-popup]');
      const colorsTrigger = root.querySelector('[data-mp2-colors-open]');
      let colorsPrevFocus = null;
      const openColorsPopup = () => {
        if (!colorsPopup) return;
        colorsPrevFocus = document.activeElement;
        colorsPopup.hidden = false;
        colorsPopup.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => colorsPopup.setAttribute('data-mp2-colors-open', ''));
        document.body.classList.add('mp2-colors-open');
      };
      const closeColorsPopup = () => {
        if (!colorsPopup) return;
        colorsPopup.removeAttribute('data-mp2-colors-open');
        colorsPopup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-colors-open');
        setTimeout(() => { colorsPopup.hidden = true; }, 300);
        if (colorsPrevFocus && typeof colorsPrevFocus.focus === 'function') colorsPrevFocus.focus({ preventScroll: true });
      };
      if (colorsTrigger) colorsTrigger.addEventListener('click', openColorsPopup);
      if (colorsPopup) {
        colorsPopup.querySelectorAll('[data-mp2-colors-close]').forEach((el) => el.addEventListener('click', closeColorsPopup));
        colorsPopup.querySelectorAll('[data-mp2-color]').forEach((btn) => {
          btn.addEventListener('click', () => {
            // Mirror the inline swatch state + run the gallery filter so the
            // mobile color picker behaves like the desktop swatch row.
            const colorVal = btn.getAttribute('data-mp2-color') || '';
            colorBtns.forEach((b) => {
              b.classList.toggle('is-active', (b.getAttribute('data-mp2-color') || '') === colorVal);
            });
            if (colorLabel) colorLabel.textContent = colorVal ? colorVal.charAt(0).toUpperCase() + colorVal.slice(1).toLowerCase() : '';
            filterGalleryByColor(colorVal);
            closeColorsPopup();
          });
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && colorsPopup.hasAttribute('data-mp2-colors-open')) closeColorsPopup();
        });
      }

      // Upsell size drawer — opens when a multi-variant upsell CTA is clicked
      const sizeDrawerEl = root.querySelector('[data-mp2-size-drawer]');
      const sizeDrawerPanel = sizeDrawerEl ? sizeDrawerEl.querySelector('.mp2-size-drawer__panel') : null;
      let sizeDrawerPrevFocus = null;

      const openSizeDrawer = (productId) => {
        if (!sizeDrawerEl || !productId) return;
        sizeDrawerPrevFocus = document.activeElement;
        sizeDrawerEl.querySelectorAll('[data-mp2-size-product]').forEach((slide) => {
          slide.hidden = slide.getAttribute('data-mp2-size-product') !== String(productId);
        });
        sizeDrawerEl.hidden = false;
        sizeDrawerEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => sizeDrawerEl.setAttribute('data-mp2-size-drawer-open', ''));
        document.body.classList.add('mp2-size-drawer-open');
        if (sizeDrawerPanel) setTimeout(() => sizeDrawerPanel.focus({ preventScroll: true }), 360);
      };
      const closeSizeDrawer = () => {
        if (!sizeDrawerEl) return;
        sizeDrawerEl.removeAttribute('data-mp2-size-drawer-open');
        sizeDrawerEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-size-drawer-open');
        setTimeout(() => { sizeDrawerEl.hidden = true; }, 360);
        if (sizeDrawerPrevFocus && typeof sizeDrawerPrevFocus.focus === 'function') sizeDrawerPrevFocus.focus({ preventScroll: true });
      };

      root.querySelectorAll('[data-mp2-upsell-size-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openSizeDrawer(btn.getAttribute('data-mp2-upsell-size-open'));
        });
      });
      if (sizeDrawerEl) {
        sizeDrawerEl.querySelectorAll('[data-mp2-size-drawer-close]').forEach((el) => el.addEventListener('click', closeSizeDrawer));
        sizeDrawerEl.querySelectorAll('[data-mp2-size-add]').forEach((btn) => {
          btn.addEventListener('click', async (e) => {
            e.preventDefault();
            if (btn.disabled) return;
            const vid = btn.getAttribute('data-mp2-size-add');
            closeSizeDrawer();
            await ajaxAdd(vid);
          });
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && sizeDrawerEl.hasAttribute('data-mp2-size-drawer-open')) closeSizeDrawer();
        });
      }
    });

    // Reassurance ETA — fills "Pide hoy y recíbelo entre [from] - [to]"
    // with computed dates based on today + min/max delivery days.
    // Past the cutoff hour the window shifts +1 day. Weekends optional.
    document.querySelectorAll('[data-mp2-reass-eta]').forEach((el) => {
      if (el.dataset.etaInit) return;
      el.dataset.etaInit = '1';
      const tmpl = el.dataset.template || el.textContent || '';
      const min = parseInt(el.dataset.minDays, 10) || 2;
      const max = parseInt(el.dataset.maxDays, 10) || 5;
      const cutoff = parseInt(el.dataset.cutoff, 10) || 0;
      const skipWk = el.dataset.skipWeekends === '1';
      const now = new Date();
      let extra = 0;
      if (cutoff > 0 && now.getHours() >= cutoff) extra = 1;
      const shift = (d) => {
        if (!skipWk) return d;
        const day = d.getDay();
        if (day === 0) d.setDate(d.getDate() + 1);
        else if (day === 6) d.setDate(d.getDate() + 2);
        return d;
      };
      const from = new Date(now); from.setDate(from.getDate() + min + extra); shift(from);
      const to   = new Date(now); to.setDate(to.getDate() + max + extra);   shift(to);
      const lang = (document.documentElement.lang || 'es').slice(0, 2);
      const fmt = (d) => {
        try { return d.toLocaleDateString(lang, { day: 'numeric', month: 'short' }); }
        catch (e) { return d.toDateString(); }
      };
      el.textContent = tmpl
        .replace('%from%', fmt(from))
        .replace('%to%', fmt(to));
    });
  })();

  // Force story-thumb video autoplay (same pattern as shop-the-look).
  // Browsers ignore the autoplay attribute on iOS / low-power / data-saver mode;
  // mute+playsInline at runtime, retry on rejection, play/pause via IO.
  (function () {
    function initStoryVideos(root) {
      const videos = (root || document).querySelectorAll('.mp2__story-video');
      if (!videos.length) return;
      const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => { v.muted = true; v.play().catch(() => {}); });
        }
      };
      videos.forEach((v) => {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        if (v.readyState >= 2) tryPlay(v);
        else v.addEventListener('loadeddata', () => tryPlay(v), { once: true });
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) tryPlay(v);
              else if (!v.paused) v.pause();
            });
          }, { threshold: 0.1 });
          io.observe(v);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', () => initStoryVideos(document));
    document.addEventListener('shopify:section:load', (e) => initStoryVideos(e.target));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) initStoryVideos(document); });
    window.addEventListener('pageshow', () => initStoryVideos(document));
  })();

  // Mobile sheet-overlay — darkens the sticky gallery progressively
  // as the info column rises over it. Mirrors the moea / hover-theme
  // pattern (--sheet-overlay-opacity inline-style). Active only on
  // mobile because desktop uses a side-by-side grid, no overlap.
  (function () {
    const mq = window.matchMedia('(max-width: 1023px)');
    document.querySelectorAll('.mp2').forEach((root) => {
      const gallery = root.querySelector('.mp2__gallery');
      const info    = root.querySelector('.mp2__info');
      if (!gallery || !info) return;

      let rafId = null;
      const update = () => {
        rafId = null;
        if (!mq.matches) {
          gallery.style.removeProperty('--mp2-overlay');
          return;
        }
        const g = gallery.getBoundingClientRect();
        const i = info.getBoundingClientRect();
        // overlap = how much the info column has risen INTO the
        // gallery's vertical band. Clamp 0..gallery height.
        const overlap = Math.max(0, g.bottom - i.top);
        const span    = Math.max(1, g.height);
        const progress = Math.min(1, overlap / span);
        // Cap at 0.45 — full black is too aggressive while reading.
        gallery.style.setProperty('--mp2-overlay', (progress * 0.45).toFixed(3));
      };
      const tick = () => { if (rafId == null) rafId = requestAnimationFrame(update); };

      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      mq.addEventListener && mq.addEventListener('change', tick);
      update();
    });
  })();

  // Gallery zoom modal — clicks on .mp2__zoom open a fullscreen <dialog> with
  // the currently-active gallery media (image or video) cloned inside.
  (function () {
    document.querySelectorAll('.mp2').forEach((root) => {
      const trigger = root.querySelector('[data-mp2-zoom]');
      const modal   = root.querySelector('[data-mp2-zoom-modal]');
      const inner   = root.querySelector('[data-mp2-zoom-inner]');
      const closeBtn = root.querySelector('[data-mp2-zoom-close]');
      if (!trigger || !modal || !inner) return;

      const openZoom = () => {
        const activeDot = root.querySelector('.mp2__dot.is-active');
        const idx = activeDot ? activeDot.getAttribute('data-mp2-dot') : '0';
        const media = root.querySelector('[data-mp2-media="' + idx + '"]');
        const src = media && (media.querySelector('img, video'));
        inner.innerHTML = '';
        if (src) {
          const clone = src.cloneNode(true);
          if (clone.tagName === 'IMG') {
            clone.removeAttribute('loading');
            clone.removeAttribute('sizes');
          } else if (clone.tagName === 'VIDEO') {
            clone.muted = true; clone.autoplay = true; clone.loop = true; clone.playsInline = true;
            clone.controls = true;
          }
          inner.appendChild(clone);
        }
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
      };
      const closeZoom = () => {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
        inner.innerHTML = '';
        document.documentElement.style.overflow = '';
      };

      trigger.addEventListener('click', openZoom);
      if (closeBtn) closeBtn.addEventListener('click', closeZoom);
      // Click on backdrop area (outside the inner content) closes too
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeZoom();
      });
      modal.addEventListener('cancel', closeZoom);
    });
  })();

  // Accordion: independent items (multiple can be open). Clicking one expands
  // it downward; items above keep their position. The first one is open by
  // default server-side.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"] && !Shopify.designMode) return;
  try {
    
  // Pill text rotator — swaps .is-active on a 3s interval so each
  // frame's slide+fade transition fires in turn. Width adaptation
  // is handled in CSS: inactive frames are position:absolute (don't
  // contribute to the rotator's intrinsic width), so the badge
  // resizes to whichever frame is currently active.
  (function () {
    function bootRotators() {
      document.querySelectorAll('.mp2__pill-rotator').forEach((rotator) => {
        if (rotator.dataset.rotatorInit) return;
        rotator.dataset.rotatorInit = '1';
        const frames = rotator.querySelectorAll('.mp2__pill-frame');
        if (frames.length < 2) {
          if (frames[0]) frames[0].classList.add('is-active');
          return;
        }
        let active = 0;
        frames[active].classList.add('is-active');
        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) return;
        setInterval(() => {
          frames[active].classList.remove('is-active');
          active = (active + 1) % frames.length;
          frames[active].classList.add('is-active');
        }, 3000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootRotators);
    } else {
      bootRotators();
    }
  })();

  // Mobile section reorder — on PDP we push two trust elements up
  // ahead of the spec table:
  //   1. pdp-ticker (benefits marquee) lands just BEFORE product-row
  //   2. product-row (which renders .pdp-brand-carousel) lands just
  //      BEFORE pdp-spec-duo
  // Net mobile order: main → pdp-ticker → product-row (brand
  // carousel) → pdp-spec-duo → rest. Idempotent + resize-aware so
  // the order flips back on desktop when the viewport crosses the
  // 1023px breakpoint.
  (function () {
    const MOBILE_MQ = window.matchMedia('(max-width: 1023px)');
    function placeBefore(node, anchor) {
      if (!node || !anchor) return;
      const isBeforeAnchor = !!(anchor.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_PRECEDING);
      if (MOBILE_MQ.matches) {
        if (!isBeforeAnchor) anchor.parentNode.insertBefore(node, anchor);
      } else if (isBeforeAnchor) {
        // Restore: drop node right after anchor (close enough to
        // the template's original DOM order without re-traversing
        // every sibling).
        if (anchor.nextSibling !== node) {
          anchor.parentNode.insertBefore(node, anchor.nextSibling);
        }
      }
    }
    function reorder() {
      // Only run when a PDP is on the page (.mp2 root sits inside
      // .shopify-section.section-main-product-v2).
      if (!document.querySelector('.mp2')) return;
      const productRow = document.querySelector('.shopify-section.section-product-row');
      const specDuo = document.querySelector('.shopify-section.section-pdp-spec-duo');
      const ticker = document.querySelector('.shopify-section.section-pdp-ticker');
      // Order matters: product-row must land before spec-duo FIRST,
      // then we can drop the ticker right before the (now-moved)
      // product-row.
      placeBefore(productRow, specDuo);
      placeBefore(ticker, productRow);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reorder);
    } else {
      reorder();
    }
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', reorder);
    else if (MOBILE_MQ.addListener) MOBILE_MQ.addListener(reorder);
  })();

  (function () {
    // Stock urgency tiers for the size selector. Assigns each in-stock
    // variant a tier (high / medium / low) using a deterministic random
    // seeded by (productId, variantId) plus a per-visitor salt held in
    // localStorage. Result is cached in localStorage so the same visitor
    // always sees the same tier across reloads — but two different
    // visitors will see different distributions, so it doesn't feel fake.
    // Tier copy: high → "En stock" (green); medium → "Pocas unidades"
    // (orange); low → "X unidades disponibles" with X random 1–4 (orange).
    // If the variant is genuinely sold out, Liquid already swapped the
    // label to the sold-out version; this JS skips those.
    const STOCK_VISITOR_SALT_KEY = 'pamp_stock_visitor_salt';
    const STOCK_TIER_KEY = (pid, vid) => `pamp_stock_${pid}_${vid}`;
    function getVisitorSalt() {
      try {
        let s = localStorage.getItem(STOCK_VISITOR_SALT_KEY);
        if (!s) {
          s = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
          localStorage.setItem(STOCK_VISITOR_SALT_KEY, s);
        }
        return s;
      } catch (e) { return 'fallback'; }
    }
    function hash01(str) {
      let h = 2166136261 >>> 0;
      for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619) >>> 0;
      }
      return (h >>> 0) / 4294967296;
    }
    function getStockTier(productId, variantId) {
      const cacheKey = STOCK_TIER_KEY(productId, variantId);
      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
        if (cached && cached.tier) return cached;
      } catch (e) {}
      const salt = getVisitorSalt();
      const seed = `${salt}|${productId}|${variantId}`;
      const r1 = hash01(seed);
      let tier, count = null;
      // Distribution: 55% high, 30% medium, 15% low.
      if (r1 < 0.55) tier = 'high';
      else if (r1 < 0.85) tier = 'medium';
      else {
        tier = 'low';
        const r2 = hash01(seed + '|count');
        count = 1 + Math.floor(r2 * 4); // 1..4
      }
      const out = { tier: tier, count: count };
      try { localStorage.setItem(cacheKey, JSON.stringify(out)); } catch (e) {}
      return out;
    }
    function applyStockTiers(root) {
      const productId = root.dataset.mp2ProductId;
      if (!productId) return;
      root.querySelectorAll('[data-mp2-stock-status]').forEach((el) => {
        const variantId = el.dataset.mp2VariantId;
        if (!variantId) return;
        const t = getStockTier(productId, variantId);
        el.setAttribute('data-mp2-stock-tier', t.tier);
        if (t.tier === 'high') {
          el.removeAttribute('data-mp2-stock-count');
          el.textContent = 'En stock';
        } else if (t.tier === 'medium') {
          el.removeAttribute('data-mp2-stock-count');
          el.textContent = 'Pocas unidades';
        } else {
          const c = t.count || 2;
          el.setAttribute('data-mp2-stock-count', String(c));
          el.textContent = c === 1
            ? '1 unidad disponible'
            : `${c} unidades disponibles`;
        }
      });
    }

    document.querySelectorAll('.mp2').forEach((root) => {
      // Stock urgency runs first so the size dialog is correct on open.
      applyStockTiers(root);
      const form = root.querySelector('[data-mp2-form]');
      if (!form) return;

      // Mobile sticky buy bar — two visible windows:
      //   (a) initial state: visible above the fold so the user has
      //       a one-tap path to the size popover before any scroll
      //   (b) post-CTA: reappears once the in-flow .mp2__cta-anchor
      //       has scrolled past the viewport top — nudges the user
      //       back to checkout after they've left the natural CTA
      //       behind.
      // While the user is reading the page (between first scroll and
      // passing the CTA) the bar disappears so it doesn't compete
      // with the in-flow CTA they're actively heading toward.
      // Click on the bar synthesises a click on [data-mp2-cta] so
      // the size popover opens directly (same funnel as the natural
      // CTA, no scroll detour). Desktop hides the bar via CSS.
      const mobileMQ = window.matchMedia('(max-width: 1023px)');
      const stickyBar = root.querySelector('[data-mp2-sticky-bar]');
      const stickyBarBtn = root.querySelector('[data-mp2-sticky-bar-trigger]');
      const inFlowCtaEl = root.querySelector('[data-mp2-cta]');
      const ctaAnchorEl = root.querySelector('.mp2__cta-anchor');
      let hasScrolled = false;
      const footerEl = document.querySelector('.shopify-section.section-footer, footer, .site-footer');
      const updateStickyBar = () => {
        if (!mobileMQ.matches) {
          root.classList.remove('is-sticky-bar-active');
          return;
        }
        // Ocultar si el footer ya entró en el viewport.
        if (footerEl) {
          const footerRect = footerEl.getBoundingClientRect();
          if (footerRect.top < window.innerHeight) {
            root.classList.remove('is-sticky-bar-active');
            return;
          }
        }
        // Mostrar solo cuando el CTA natural ya pasó por arriba del viewport.
        let shouldShow = false;
        if (ctaAnchorEl) {
          const ctaRect = ctaAnchorEl.getBoundingClientRect();
          shouldShow = ctaRect.bottom < 0;
        }
        root.classList.toggle('is-sticky-bar-active', shouldShow);
      };
      window.addEventListener('scroll', () => {
        hasScrolled = true;
        updateStickyBar();
      }, { passive: true });
      window.addEventListener('resize', updateStickyBar);
      mobileMQ.addEventListener && mobileMQ.addEventListener('change', updateStickyBar);
      updateStickyBar();
      if (stickyBarBtn) {
        stickyBarBtn.addEventListener('click', (e) => {
          // Delegate to the in-flow CTA so the existing handler
          // (open size popover OR add-to-cart, depending on whether
          // a size is already picked) runs end-to-end. Same anchor
          // for both buttons → identical funnel, no confusion.
          // stopPropagation prevents the document-level "click
          // outside the popover" handler defined below from firing
          // on the same tick and immediately closing the popover
          // that the synthesised CTA click just opened.
          e.preventDefault();
          e.stopPropagation();
          if (inFlowCtaEl) inFlowCtaEl.click();
        });
      }
      const variantInput = form.querySelector('[data-mp2-variant-id]');
      const colorBtns = root.querySelectorAll('[data-mp2-color]');
      const colorLabel = root.querySelector('[data-mp2-color-name]');
      const colorDot = root.querySelector('[data-mp2-color-dot]');
      const heightBtns = root.querySelectorAll('[data-mp2-height]');
      const heightLabel = root.querySelector('[data-mp2-height-name]');
      const cta = root.querySelector('[data-mp2-cta]');
      const popover = root.querySelector('[data-mp2-popover]');
      const popoverClose = root.querySelector('[data-mp2-popover-close]');
      const sizeBtns = root.querySelectorAll('[data-mp2-size]');

      // Variant resolution from option state — supports 2 or 3-option products
      // (Color + Size, or Color + Height + Size). Read once from JSON injected
      // by swatches_block; falls back to precomputed data-mp2-variant when
      // state is incomplete.
      const productDataNode = root.querySelector('[data-mp2-product-data]');
      let optionNames = [];
      let variantsList = [];
      if (productDataNode) {
        try {
          const parsed = JSON.parse(productDataNode.textContent || '{}');
          optionNames = parsed.options || [];
          variantsList = parsed.variants || [];
        } catch (_) {}
      }
      // Tokenise option name on word boundaries so localized variants
      // ("Talla (Mexico)", "Talla MX", "Color principal") match the key
      // lists. Exact match used to fail in MX where the option is named
      // "Talla (Mexico)" → sizeOptionName became undefined → optionState
      // never updated on size click → resolveVariant always returned the
      // INITIAL variant → every "Add to cart" sent the first variant ID.
      const findOption = (matches) => optionNames.find((n) => {
        const tokens = (n || '').trim().toLowerCase().split(/[\s\-_()]+/).filter(Boolean);
        return tokens.some((t) => matches.indexOf(t) !== -1);
      });
      const colorOptionName = findOption(['color', 'colour', 'couleur', 'farbe']);
      const heightOptionName = findOption(['height', 'altura', 'hauteur']);
      const sizeOptionName = findOption(['size', 'talla', 'taille', 'tamaño', 'tamanho', 'größe']);
      const initialId = variantInput ? variantInput.value : null;
      const initialVariant =
        variantsList.find((v) => String(v.id) === String(initialId)) || variantsList[0] || {};
      const optionState = {};
      optionNames.forEach((name, idx) => {
        optionState[name] = initialVariant['option' + (idx + 1)];
      });
      const resolveVariant = () => {
        if (!variantsList.length || !optionNames.length) return null;
        return variantsList.find((v) =>
          optionNames.every((n, i) => v['option' + (i + 1)] === optionState[n])
        );
      };
      // ----- Variant price display ------------------------------------
      // Parsed once. Map { variantId: { now: '€75,95', was: '€140,95'|null } }
      let mp2PriceMap = {};
      try {
        const _pn = root.querySelector('[data-mp2-variant-prices]');
        if (_pn) mp2PriceMap = JSON.parse(_pn.textContent || '{}') || {};
      } catch (e) { /* silent — prices just won't refresh */ }

      const priceWrapEl = root.querySelector('.mp2__price');
      const priceNowEl  = root.querySelector('.mp2__price-now');
      const saleTagEl   = root.querySelector('[data-mp2-sale-tag]');
      const priceSaveEl = root.querySelector('[data-mp2-price-save]');
      const savingsEl   = root.querySelector('[data-mp2-savings]');

      const updatePriceDisplay = (variantId) => {
        if (!variantId) return;
        const entry = mp2PriceMap[String(variantId)];
        if (!entry || !priceWrapEl || !priceNowEl) return;

        priceNowEl.textContent = entry.now;

        // .mp2__price-was is only present in markup when the INITIAL
        // variant was on sale. When switching to/from a sale variant we
        // need to inject or remove it so the campaign-styles :has() rule
        // and the strikethrough display stay consistent with reality.
        let priceWasEl = priceWrapEl.querySelector('.mp2__price-was');
        if (entry.was) {
          if (!priceWasEl) {
            priceWasEl = document.createElement('s');
            priceWasEl.className = 'mp2__price-was';
            priceWrapEl.insertBefore(priceWasEl, priceNowEl);
          }
          priceWasEl.textContent = entry.was;
          priceWrapEl.classList.add('is-on-sale');
        } else {
          if (priceWasEl) priceWasEl.remove();
          priceWrapEl.classList.remove('is-on-sale');
        }

        // Sale-tag ("Sale" red chip above the title) + savings line
        // ("Ahorra €X.XX") visibility — both ride the same on-sale
        // signal as the strikethrough above. `hidden` attribute keeps
        // them out of the layout when the active variant isn't on sale.
        if (saleTagEl) {
          if (entry.was) saleTagEl.removeAttribute('hidden');
          else saleTagEl.setAttribute('hidden', '');
          if (saleTagEl.dataset.cmpTag && entry.pct) saleTagEl.textContent = saleTagEl.dataset.cmpTag + ' -' + entry.pct + '%';
        }
        if (priceSaveEl) {
          if (entry.save) {
            priceSaveEl.removeAttribute('hidden');
            if (savingsEl) savingsEl.textContent = entry.save;
          } else {
            priceSaveEl.setAttribute('hidden', '');
          }
        }
      };

      const syncVariantInput = () => {
        const v = resolveVariant();
        if (v && variantInput) variantInput.value = v.id;
        if (v) updatePriceDisplay(v.id);
        return v;
      };

      // Paint the initial state — covers URLs that pre-select a variant.
      const _initialVariant = resolveVariant();
      if (_initialVariant) updatePriceDisplay(_initialVariant.id);
      const upsellTrack = root.querySelector('[data-mp2-upsell-track]');
      const upsellPrev = root.querySelector('[data-mp2-upsell-prev]');
      const upsellNext = root.querySelector('[data-mp2-upsell-next]');

      // Gallery dots tracking — activate the dot whose media is most in view,
      // and toggle is-gallery-active while the gallery column is visible.
      const dots = root.querySelectorAll('[data-mp2-dot]');
      const medias = root.querySelectorAll('[data-mp2-media]');
      const galleryEl = root.querySelector('[data-fig="85:6"]');
      if (dots.length && medias.length && 'IntersectionObserver' in window) {
        const setActive = (idx) => {
          dots.forEach((d) => d.classList.remove('is-active'));
          const active = root.querySelector('[data-mp2-dot="' + idx + '"]');
          if (active) active.classList.add('is-active');
        };
        const io = new IntersectionObserver((entries) => {
          let best = null, bestRatio = 0;
          entries.forEach((e) => {
            if (e.intersectionRatio > bestRatio) { best = e.target; bestRatio = e.intersectionRatio; }
          });
          if (best) setActive(best.getAttribute('data-mp2-media'));
        }, { threshold: [0.25, 0.5, 0.75, 1], rootMargin: '-30% 0px -30% 0px' });
        medias.forEach((m) => io.observe(m));
      }
      if (galleryEl && 'IntersectionObserver' in window) {
        const io2 = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            root.classList.toggle('is-gallery-active', e.isIntersecting);
          });
        }, { threshold: 0, rootMargin: '-20px 0px -20px 0px' });
        io2.observe(galleryEl);
      }

      // -----------------------------------------------------
      // Color filter — hide gallery medias whose img alt doesn't match the
      // active color. Matching is normalized: lowercase, accents stripped,
      // spaces → hyphens. Alt may contain extra text ("Negro / front view")
      // — substring match catches it. If NO media matches, show all (safe
      // fallback so a misconfigured product never renders an empty gallery).
      // -----------------------------------------------------
      const _deburrMap = { 'á':'a','é':'e','í':'i','ó':'o','ú':'u','ü':'u','ñ':'n','Á':'a','É':'e','Í':'i','Ó':'o','Ú':'u','Ü':'u','Ñ':'n' };
      const normalizeColor = (raw) => {
        if (!raw) return '';
        let s = String(raw).trim().replace(/^#?color[_-]/i, '').replace(/^#/, '');
        s = s.replace(/[áéíóúüñÁÉÍÓÚÜÑ]/g, (ch) => _deburrMap[ch] || ch);
        return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      };

      const getActiveColorValue = () => {
        const active = root.querySelector('[data-mp2-color].is-active');
        if (active) return active.getAttribute('data-mp2-color') || '';
        const checked = root.querySelector('input[type="radio"][name*="olor" i]:checked, input[type="radio"][name*="Color" i]:checked');
        if (checked && checked.value) return checked.value;
        const select = root.querySelector('select[name*="olor" i], select[name*="Color" i]');
        if (select && select.value) return select.value;
        const firstBtn = root.querySelector('[data-mp2-color]');
        return firstBtn ? (firstBtn.getAttribute('data-mp2-color') || '') : '';
      };

     const galleryStack = root.querySelector('[data-mp2-gallery]');

const filterGalleryByColor = (rawColor, opts) => {
  const scrollToFirst = !!(opts && opts.scrollToFirst);
  const cn = normalizeColor(rawColor);
  if (!medias.length) return;
  let matches = 0;
  let firstVisibleIdx = -1;
  medias.forEach((m, idx) => {
    const img = m.querySelector('img');
    const altNorm = normalizeColor(img && img.alt);
    const ok = !cn || (altNorm && (Array.prototype.some.call(medias, (mm) => { const ii = mm.querySelector('img'); return normalizeColor(ii && ii.alt) === cn; }) ? altNorm === cn : altNorm.indexOf(cn) !== -1));
    if (ok) {
      matches++;
      if (firstVisibleIdx < 0) firstVisibleIdx = idx;
    }
    m.classList.toggle('mp2__media--hidden', !ok);
  });
  if (matches === 0) {
    medias.forEach((m) => m.classList.remove('mp2__media--hidden'));
    firstVisibleIdx = 0;
  }
  dots.forEach((d) => {
    const dIdx = parseInt(d.getAttribute('data-mp2-dot'), 10);
    const m = medias[dIdx];
    const hidden = !!(m && m.classList.contains('mp2__media--hidden'));
    d.classList.toggle('mp2__dot--hidden', hidden);
    d.classList.toggle('is-active', dIdx === firstVisibleIdx);
  });

  // ── NUEVO: al cambiar de color, arrancar siempre en la primera imagen ──
  if (!scrollToFirst || !galleryStack) return;
  const first = medias[firstVisibleIdx];
  if (!first) return;

  if (mobileMQ.matches) {
    // Mobile: swiper horizontal. Forzamos reflow leyendo offsetLeft y
    // desactivamos momentáneamente scroll-behavior:smooth del CSS para
    // que el salto sea instantáneo (sin animación "rebobinando").
    const prevBehavior = galleryStack.style.scrollBehavior;
    galleryStack.style.scrollBehavior = 'auto';
    galleryStack.scrollLeft = first.offsetLeft - galleryStack.offsetLeft;
    requestAnimationFrame(() => { galleryStack.style.scrollBehavior = prevBehavior; });
  } else {
    // Desktop: stack vertical en flujo de página. Solo subimos si el
    // usuario ya había scrolleado por debajo del inicio de la galería.
    const top = galleryStack.getBoundingClientRect().top;
    if (top < 0) {
      const headerOffset = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--site-header-offset'), 10
      ) || 0;
      window.scrollTo({ top: window.scrollY + top - headerOffset, behavior: 'auto' });
    }
  }
};

      // Helper: paint the label text + dot from a swatch button's data.
      // Used by click (commit), mouseenter (hover preview) and
      // mouseleave (revert to the active swatch).
      const applyColorVisual = (colorVal, swatchStyle) => {
        if (colorLabel) colorLabel.textContent = colorVal ? colorVal.charAt(0).toUpperCase() + colorVal.slice(1).toLowerCase() : '';
        if (colorDot) {
          colorDot.setAttribute('title', colorVal);
          if (swatchStyle) colorDot.setAttribute('style', swatchStyle);
          else colorDot.removeAttribute('style');
        }
      };
      const restoreActiveColorVisual = () => {
        const active = root.querySelector('[data-mp2-color].is-active') || colorBtns[0];
        if (!active) return;
        applyColorVisual(
          active.getAttribute('data-mp2-color') || '',
          active.getAttribute('data-mp2-color-style') || ''
        );
      };

      // ─── Refresh the size list (availability + stock labels) when ──
      // the active color or height changes. Liquid renders the size
      // rows once with the INITIAL color/height combo; without this,
      // switching to a different color/height kept the OLD sold-out
      // states and stock-tier labels — sizes that should be sold out
      // showed "In stock" and vice versa.
      const refreshSizeAvailability = () => {
        const sizesList = root.querySelector('.mp2__sizes');
        if (!sizesList || !sizeOptionName || !variantsList.length) return;
        const inStockLabel = sizesList.dataset.mp2InStockLabel || 'In stock';
        const soldOutLabel = sizesList.dataset.mp2SoldOutLabel || 'Sold out';
        const notifyLabel = sizesList.dataset.mp2NotifyLabel || 'Notify me';

        sizeBtns.forEach((btn) => {
          const sizeVal = btn.getAttribute('data-mp2-size');
          const row = btn.closest('.mp2__size-row');
          if (!row || !sizeVal) return;
          // Find variant that matches: current color + current height + this size
          const v = variantsList.find((variant) =>
            optionNames.every((name, i) => {
              if (name === sizeOptionName) return variant['option' + (i + 1)] === sizeVal;
              return variant['option' + (i + 1)] === optionState[name];
            })
          );
          const available = !!(v && v.available);
          const vid = v ? v.id : '';
          // Update button state
          if (vid) btn.setAttribute('data-mp2-variant', vid);
          if (available) {
            row.classList.remove('is-unavailable');
            btn.disabled = false;
            btn.removeAttribute('aria-disabled');
          } else {
            row.classList.add('is-unavailable');
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          }
          // Wipe existing status + notify and rebuild for the new state.
          const oldStatus = row.querySelector('.mp2__size-status');
          if (oldStatus) oldStatus.remove();
          const oldNotify = row.querySelector('.mp2__size-notify');
          if (oldNotify) oldNotify.remove();
          if (available) {
            const statusEl = document.createElement('span');
            statusEl.className = 'mp2__size-status';
            statusEl.setAttribute('data-mp2-stock-status', '');
            statusEl.setAttribute('data-mp2-variant-id', String(vid));
            statusEl.textContent = inStockLabel;
            row.appendChild(statusEl);
          } else {
            const statusEl = document.createElement('span');
            statusEl.className = 'mp2__size-status mp2__size-status--out';
            statusEl.textContent = soldOutLabel;
            row.appendChild(statusEl);
            if (vid) {
              const notifyEl = document.createElement('a');
              notifyEl.className = 'mp2__size-notify klaviyo-bis-trigger';
              notifyEl.setAttribute('data-variant-id', String(vid));
              notifyEl.href = '#notify-' + vid;
              notifyEl.innerHTML = '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M4 11h6m-7.5-2h9L10 6.5V5a3 3 0 0 0-6 0v1.5L2.5 9z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + notifyLabel + '</span>';
              row.appendChild(notifyEl);
            }
          }
        });
        // Re-run the synthetic urgency tiers on the freshly-rebuilt
        // status spans (they now have the new variant ids).
        if (typeof applyStockTiers === 'function') applyStockTiers(root);
      };

      colorBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          colorBtns.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const colorVal = btn.getAttribute('data-mp2-color') || '';
          const swatchStyle = btn.getAttribute('data-mp2-color-style') || '';
          applyColorVisual(colorVal, swatchStyle);
          if (colorOptionName) optionState[colorOptionName] = colorVal;
          syncVariantInput();
          filterGalleryByColor(colorVal, { scrollToFirst: true });
          refreshSizeAvailability();
        });
        // Hover preview: temporarily swap the label + dot to the
        // hovered swatch so the merchandiser sees "Negro y dorado /
        // Tecnología BOOSTHEIGHT™" as they point at different colors,
        // without committing the selection.
        btn.addEventListener('mouseenter', () => {
          applyColorVisual(
            btn.getAttribute('data-mp2-color') || '',
            btn.getAttribute('data-mp2-color-style') || ''
          );
        });
        btn.addEventListener('mouseleave', restoreActiveColorVisual);
      });

      // Same pattern as the color swatches: paint the height label
      // text from a pill's data-mp2-height. Used by click (commit),
      // mouseenter (hover preview) and mouseleave (revert).
      const applyHeightVisual = (heightVal) => {
        if (heightLabel) heightLabel.textContent = heightVal ? heightVal.charAt(0).toUpperCase() + heightVal.slice(1).toLowerCase() : '';
      };
      const restoreActiveHeightVisual = () => {
        const active = root.querySelector('[data-mp2-height].is-active') || heightBtns[0];
        if (!active) return;
        applyHeightVisual(active.getAttribute('data-mp2-height') || '');
      };

     heightBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        heightBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const heightVal = btn.getAttribute('data-mp2-height') || '';
        applyHeightVisual(heightVal);
        // ── NUEVO: sincroniza el encabezado del popover "TALLA • +XCM"
        const popCurrent = root.querySelector('[data-mp2-size-current]');
        if (popCurrent) popCurrent.textContent = heightVal;
        // ─────────────────────────────────────────────────────────────
        if (heightOptionName) optionState[heightOptionName] = heightVal;
        syncVariantInput();
        refreshSizeAvailability();
      });

        // Hover preview — swap the "Altura / +XCM" label to whichever
        // pill the merchant is pointing at, then revert on leave.
        btn.addEventListener('mouseenter', () => {
          applyHeightVisual(btn.getAttribute('data-mp2-height') || '');
        });
        btn.addEventListener('mouseleave', restoreActiveHeightVisual);
      });

      // Initial filter on load — covers shop URLs that pre-select a color
      filterGalleryByColor(getActiveColorValue());

      // Cross-section: listen to native variant form changes too
      root.addEventListener('change', (e) => {
        const tgt = e.target;
        if (!tgt || !tgt.matches) return;
        if (tgt.matches('input[type="radio"][name*="olor" i], input[type="radio"][name*="Color" i], select[name*="olor" i], select[name*="Color" i]')) {
          filterGalleryByColor(tgt.value);
        }
      });

      // Popover open replaces the CTA (and Klarna text) in place on desktop
      // — the anchor gets is-popover-open and CSS hides the CTA/klarna so
      // the popover slides into the same row position. On mobile the same
      // class triggers a bottom-sheet treatment via CSS and the backdrop is
      // un-hidden so taps outside the sheet close it.
      const ctaAnchor = root.querySelector('.mp2__cta-anchor');
      const popoverBackdrop = root.querySelector('.mp2__popover-backdrop');
      function openPop() {
        if (popover) popover.hidden = false;
        if (popoverBackdrop) popoverBackdrop.hidden = false;
        if (ctaAnchor) ctaAnchor.classList.add('is-popover-open');
        document.body.classList.add('mp2-popover-open');
      }
      function closePop() {
        if (popover) popover.hidden = true;
        if (popoverBackdrop) popoverBackdrop.hidden = true;
        if (ctaAnchor) ctaAnchor.classList.remove('is-popover-open');
        document.body.classList.remove('mp2-popover-open');
      }

      async function ajaxAdd(variantId) {
        // Full-lifecycle trace — every phase logged with delta-ms since
        // the click. Pinpoints where time goes (network vs parse vs
        // render). Trace ID groups logs across phases in console.
        const T0 = performance.now();
        const traceId = Math.floor(Math.random() * 9999);
        const trace = (label, extra) => {
          const dt = (performance.now() - T0).toFixed(0);
          console.log('%c[ATC#' + traceId + '] +' + dt + 'ms %c' + label,
            'background:#f30;color:#fff;padding:1px 5px;font-weight:bold',
            'color:#f30;font-weight:bold', extra || '');
        };
        trace('ajaxAdd START', { variantId });
        try {
          if (variantId && variantInput) variantInput.value = variantId;
          const fd = new FormData(form);
          trace('fetch /cart/add.js?sections=cart-drawer SEND');
          const addP  = fetch('/cart/add.js?sections=cart-drawer&sections-url=/', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          const addRes = await addP;
          trace('add.js RESPONSE headers', { status: addRes.status, ok: addRes.ok });
          if (!addRes.ok) { const e = await addRes.json().catch(() => ({})); throw new Error(e.description || 'add failed'); }
          const addJson = await addRes.json();
          trace('add.js BODY parsed', { hasSections: !!(addJson && addJson.sections), htmlLen: addJson && addJson.sections && addJson.sections['cart-drawer'] ? addJson.sections['cart-drawer'].length : 0 });
          const sectionsHtml = addJson && addJson.sections && addJson.sections['cart-drawer'];
          trace('fetch /cart.js SEND (parallel)');
          const cartP = fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then((r) => { trace('cart.js RESPONSE headers', { status: r.status }); return r.json(); })
            .then((c) => { trace('cart.js BODY parsed', { itemCount: c && c.item_count }); return c; });
          // Embed trace fn in the event so cart-drawer can log into the
          // same lifecycle and we see the full picture in one console group.
          window.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { sectionsHtml: sectionsHtml || null, cartPromise: cartP, _trace: trace }
          }));
          trace('cart:item-added DISPATCHED');
        } catch (err) { trace('ERROR', err && err.message); console.error(err); form.submit(); }
      }

      if (cta) {
        cta.addEventListener('click', async (e) => {
          e.preventDefault();
          if (popover) { if (popover.hidden) openPop(); else closePop(); }
          else {
            // Single-variant product (no popover) — open drawer immediately
            // for instant feedback while /cart/add.js resolves in BG.
            window.dispatchEvent(new CustomEvent('cart:open-drawer:force'));
            await ajaxAdd();
          }
        });
      }
      if (popoverClose) popoverClose.addEventListener('click', closePop);
      document.addEventListener('click', (e) => {
        if (!popover || popover.hidden) return;
        // Don't close on clicks INSIDE the popover, on the in-flow
        // CTA, or on the sticky-bar trigger (which delegates to the
        // CTA and would otherwise be flagged as an outside click).
        if (popover.contains(e.target)) return;
        if (cta && cta.contains(e.target)) return;
        if (stickyBarBtn && stickyBarBtn.contains(e.target)) return;
        closePop();
      });

      sizeBtns.forEach((btn) => {
        btn.addEventListener('click', async () => {
          if (btn.disabled) return;
          const sizeVal = btn.getAttribute('data-mp2-size') || '';
          if (sizeOptionName) optionState[sizeOptionName] = sizeVal;
          const resolved = syncVariantInput();
          // Prefer resolveVariant() result so the COLOR (and height)
          // currently picked by the user is honoured — the button's
          // data-mp2-variant attribute is baked at render time from the
          // initial color, so it ignores any color change made after
          // load. resolved.id reflects the full current optionState
          // (now correct since findOption tokenises localized names
          // like "Talla (Mexico)"). Fallback to the btn attr only if
          // no variant matches the state (e.g. invalid combo).
          const vid = (resolved && resolved.id) || btn.getAttribute('data-mp2-variant');
          closePop();
          // Loading state — once popover is closed the CTA re-appears,
          // we immediately switch it to the spinner so the user doesn't
          // see "ELIGE TU TALLA" flash back before the cart opens.
          if (cta) cta.classList.add('is-loading');
          // Open the cart drawer IMMEDIATELY so the user sees instant
          // feedback (existing cart contents) instead of staring at the
          // PDP for ~2-3s while /cart/add.js resolves. When the add lands,
          // the new item appears in the body via cart:item-added → refresh.
          window.dispatchEvent(new CustomEvent('cart:open-drawer:force'));
          // Inject an optimistic skeleton row into the cart drawer so the
          // user sees THEIR product in the cart NOW, not 1.3s from now
          // when add.js returns. Morph replaces it with the real row when
          // the server response arrives. Resolves variant data from the
          // parsed product JSON so the image/title/variant/price match
          // what the server will eventually render.
          const optimisticVariant = variantsList.find(function (v) { return String(v.id) === String(vid); });
          if (optimisticVariant) {
            const pTitleEl = root.querySelector('.mp2__title');
            const pNowEl = root.querySelector('.mp2__price-now');
            window.dispatchEvent(new CustomEvent('cart:optimistic-add', {
              detail: {
                variantId: vid,
                image: (optimisticVariant.featured_image && optimisticVariant.featured_image.src)
                  || (optimisticVariant.featured_media && optimisticVariant.featured_media.preview_image && optimisticVariant.featured_media.preview_image.src)
                  || null,
                title: pTitleEl ? pTitleEl.textContent.trim() : '',
                variantTitle: optimisticVariant.public_title || optimisticVariant.title || '',
                formattedPrice: pNowEl ? pNowEl.textContent.trim() : '',
              }
            }));
          }
          try {
            await ajaxAdd(vid);
          } finally {
            // ajaxAdd fires cart:item-added → cart drawer opens at the
            // same instant the fetch resolves. Drop the spinner now so
            // the CTA quietly returns to normal underneath the open
            // drawer (visible again if the user closes the drawer).
            if (cta) cta.classList.remove('is-loading');
          }
        });
      });

      // Expand the click target to the entire .mp2__size-row so the
      // user can tap anywhere on the row (status label, empty space)
      // and not just the underlined number. The "Notify me" anchor on
      // sold-out variants is excluded so its own navigation still
      // works, and is-unavailable rows are skipped entirely.
      root.querySelectorAll('.mp2__size-row').forEach((row) => {
        if (row.classList.contains('is-unavailable')) return;
        row.addEventListener('click', (e) => {
          if (e.target.closest('.mp2__size-notify, [data-mp2-size]')) return;
          const inner = row.querySelector('[data-mp2-size]');
          if (inner && !inner.disabled) inner.click();
        });
      });

      // Upsell pairs-well-with scroll
      if (upsellTrack) {
        const step = () => upsellTrack.clientWidth * 0.92;
        if (upsellPrev) upsellPrev.addEventListener('click', () => upsellTrack.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (upsellNext) upsellNext.addEventListener('click', () => upsellTrack.scrollBy({ left: step(), behavior: 'smooth' }));
      }

      // Upsell card CTA = AJAX add its variant
      root.querySelectorAll('[data-mp2-upsell-buy]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const vid = btn.getAttribute('data-mp2-upsell-buy');
          await ajaxAdd(vid);
        });
      });

      // Accordion drawer — opened by drawer_block links + Size Guide chip
      const drawerEl = root.querySelector('[data-mp2-drawer]');
      const drawerTitle = root.querySelector('[data-mp2-drawer-title]');
      const drawerBody = drawerEl ? drawerEl.querySelector('.mp2-drawer__body') : null;
      const drawerPanel = drawerEl ? drawerEl.querySelector('.mp2-drawer__panel') : null;
      let drawerPrevFocus = null;

      const openDrawer = (slot, label) => {
        if (!drawerEl) return;
        drawerPrevFocus = document.activeElement;
        drawerEl.hidden = false;
        drawerEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => drawerEl.setAttribute('data-mp2-drawer-open', ''));
        document.body.classList.add('mp2-drawer-open');
        if (drawerTitle) drawerTitle.textContent = label || '';
        drawerEl.querySelectorAll('.mp2-drawer__section').forEach((s) => {
          s.open = s.getAttribute('data-mp2-drawer-slot') === slot;
        });
        const target = slot && drawerEl.querySelector('[data-mp2-drawer-slot="' + slot + '"]');
        if (target && drawerBody) {
          setTimeout(() => { drawerBody.scrollTop = Math.max(0, target.offsetTop - 8); }, 50);
        }
        if (drawerPanel) setTimeout(() => drawerPanel.focus({ preventScroll: true }), 360);
      };
      const closeDrawer = () => {
        if (!drawerEl) return;
        drawerEl.removeAttribute('data-mp2-drawer-open');
        drawerEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-drawer-open');
        setTimeout(() => { drawerEl.hidden = true; }, 350);
        if (drawerPrevFocus && typeof drawerPrevFocus.focus === 'function') drawerPrevFocus.focus({ preventScroll: true });
      };

      root.querySelectorAll('[data-mp2-drawer-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.getAttribute('data-mp2-drawer-empty') === 'true') return;
          const slot = btn.getAttribute('data-mp2-drawer-open');
          const label = btn.textContent.trim();
          openDrawer(slot, label);
        });
      });
      if (drawerEl) {
        drawerEl.querySelectorAll('[data-mp2-drawer-close]').forEach((el) => el.addEventListener('click', closeDrawer));
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && drawerEl.hasAttribute('data-mp2-drawer-open')) closeDrawer();
        });
      }

      // Tech detail drawer (Figma 801:1121) — open from marketing "see more" button
      const techEl = root.querySelector('[data-mp2-tech-drawer]');
      let techPrevFocus = null;
      const openTech = () => {
        if (!techEl) return;
        techPrevFocus = document.activeElement;
        techEl.hidden = false;
        techEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => techEl.setAttribute('data-mp2-tech-drawer-open', ''));
        document.body.classList.add('mp2-tech-open');
      };
      const closeTech = () => {
        if (!techEl) return;
        techEl.removeAttribute('data-mp2-tech-drawer-open');
        techEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-tech-open');
        setTimeout(() => { techEl.hidden = true; }, 360);
        if (techPrevFocus && typeof techPrevFocus.focus === 'function') techPrevFocus.focus({ preventScroll: true });
      };
      root.querySelectorAll('[data-mp2-tech-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openTech();
        });
      });
      if (techEl) {
        techEl.querySelectorAll('[data-mp2-tech-close]').forEach((el) => el.addEventListener('click', closeTech));
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && techEl.hasAttribute('data-mp2-tech-drawer-open')) closeTech();
        });
      }

      // Story lightbox — vertical video popup
      const lightboxEl = root.querySelector('[data-mp2-lightbox]');
      const lightboxSlides = lightboxEl ? Array.from(lightboxEl.querySelectorAll('[data-mp2-story-slide]')) : [];
      const lightboxPrev = lightboxEl ? lightboxEl.querySelector('[data-mp2-story-prev]') : null;
      const lightboxNext = lightboxEl ? lightboxEl.querySelector('[data-mp2-story-next]') : null;
      let lightboxIdx = 0;
      let lightboxPrevFocus = null;

      const pauseAllLightboxVideos = () => {
        lightboxSlides.forEach((s) => {
          const v = s.querySelector('video');
          if (v) { try { v.pause(); v.currentTime = 0; } catch (_) {} }
        });
      };
      const showLightboxSlide = (idx) => {
        if (!lightboxSlides.length) return;
        if (idx < 0) idx = lightboxSlides.length - 1;
        if (idx >= lightboxSlides.length) idx = 0;
        lightboxIdx = idx;
        pauseAllLightboxVideos();
        lightboxSlides.forEach((s, i) => { s.hidden = i !== idx; });
        const current = lightboxSlides[idx];
        const v = current && current.querySelector('video');
        if (v) { v.muted = false; v.play().catch(() => { v.muted = true; v.play().catch(() => {}); }); }
      };
      const openLightbox = (idx) => {
        if (!lightboxEl) return;
        lightboxPrevFocus = document.activeElement;
        lightboxEl.hidden = false;
        lightboxEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => lightboxEl.setAttribute('data-mp2-lightbox-open', ''));
        document.body.classList.add('mp2-lightbox-open');
        showLightboxSlide(idx);
      };
      const closeLightbox = () => {
        if (!lightboxEl) return;
        pauseAllLightboxVideos();
        lightboxEl.removeAttribute('data-mp2-lightbox-open');
        lightboxEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-lightbox-open');
        setTimeout(() => { lightboxEl.hidden = true; }, 260);
        if (lightboxPrevFocus && typeof lightboxPrevFocus.focus === 'function') lightboxPrevFocus.focus({ preventScroll: true });
      };

      root.querySelectorAll('[data-mp2-story-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = parseInt(btn.getAttribute('data-mp2-story-open'), 10) || 0;
          openLightbox(idx);
        });
      });
      if (lightboxEl) {
        lightboxEl.querySelectorAll('[data-mp2-lightbox-close]').forEach((el) => el.addEventListener('click', closeLightbox));
        if (lightboxPrev) lightboxPrev.addEventListener('click', () => showLightboxSlide(lightboxIdx - 1));
        if (lightboxNext) lightboxNext.addEventListener('click', () => showLightboxSlide(lightboxIdx + 1));
        document.addEventListener('keydown', (e) => {
          if (!lightboxEl.hasAttribute('data-mp2-lightbox-open')) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') showLightboxSlide(lightboxIdx - 1);
          if (e.key === 'ArrowRight') showLightboxSlide(lightboxIdx + 1);
        });
      }

      // Layered sticky stack — cumulative top offsets on desktop.
      // Layer 1 docks against the live --site-header-offset; layers 2/3 use
      // calc() referencing --site-header-offset so they re-evaluate live as
      // the header offset changes (sticky scroll, AB dismissed, hidden).
      // Static numeric values would freeze the offset to whatever the header
      // measured at section init.
      const stackLayer1 = root.querySelector('[data-mp2-layer="1"]');
      const stackLayer2 = root.querySelector('[data-mp2-layer="2"]');
      const stackLayer3 = root.querySelector('[data-mp2-layer="3"]');
      if (stackLayer1 || stackLayer2 || stackLayer3) {
        const computeStack = () => {
          const stickyFallbackStr = getComputedStyle(root).getPropertyValue('--mp2-sticky-top').trim();
          const stickyFallback = parseInt(stickyFallbackStr, 10) || 80;
          const h1 = stackLayer1 ? stackLayer1.offsetHeight : 0;
          const h2 = stackLayer2 ? stackLayer2.offsetHeight : 0;
          // Layer 1: clear any stale --mp2-layer-top so the CSS fallback
          // chain top: var(--mp2-layer-top, var(--site-header-offset, …))
          // resolves directly to --site-header-offset.
          if (stackLayer1) stackLayer1.style.removeProperty('--mp2-layer-top');
          if (stackLayer2) stackLayer2.style.setProperty('--mp2-layer-top', `calc(var(--site-header-offset, ${stickyFallback}px) + ${h1}px)`);
          if (stackLayer3) stackLayer3.style.setProperty('--mp2-layer-top', `calc(var(--site-header-offset, ${stickyFallback}px) + ${h1 + h2}px)`);
        };
        computeStack();
        window.addEventListener('resize', computeStack);
        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(computeStack);
          if (stackLayer1) ro.observe(stackLayer1);
          if (stackLayer2) ro.observe(stackLayer2);
        }
      }

      // Colors popup — bottom sheet triggered on mobile from swatches block
      const colorsPopup = root.querySelector('[data-mp2-colors-popup]');
      const colorsTrigger = root.querySelector('[data-mp2-colors-open]');
      let colorsPrevFocus = null;
      const openColorsPopup = () => {
        if (!colorsPopup) return;
        colorsPrevFocus = document.activeElement;
        colorsPopup.hidden = false;
        colorsPopup.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => colorsPopup.setAttribute('data-mp2-colors-open', ''));
        document.body.classList.add('mp2-colors-open');
      };
      const closeColorsPopup = () => {
        if (!colorsPopup) return;
        colorsPopup.removeAttribute('data-mp2-colors-open');
        colorsPopup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-colors-open');
        setTimeout(() => { colorsPopup.hidden = true; }, 300);
        if (colorsPrevFocus && typeof colorsPrevFocus.focus === 'function') colorsPrevFocus.focus({ preventScroll: true });
      };
      if (colorsTrigger) colorsTrigger.addEventListener('click', openColorsPopup);
      if (colorsPopup) {
        colorsPopup.querySelectorAll('[data-mp2-colors-close]').forEach((el) => el.addEventListener('click', closeColorsPopup));
        colorsPopup.querySelectorAll('[data-mp2-color]').forEach((btn) => {
          btn.addEventListener('click', () => {
            // Mirror the inline swatch state + run the gallery filter so the
            // mobile color picker behaves like the desktop swatch row.
            const colorVal = btn.getAttribute('data-mp2-color') || '';
            colorBtns.forEach((b) => {
              b.classList.toggle('is-active', (b.getAttribute('data-mp2-color') || '') === colorVal);
            });
            if (colorLabel) colorLabel.textContent = colorVal ? colorVal.charAt(0).toUpperCase() + colorVal.slice(1).toLowerCase() : '';
            filterGalleryByColor(colorVal, { scrollToFirst: true });
            closeColorsPopup();
          });
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && colorsPopup.hasAttribute('data-mp2-colors-open')) closeColorsPopup();
        });
      }

      // Upsell size drawer — opens when a multi-variant upsell CTA is clicked
      const sizeDrawerEl = root.querySelector('[data-mp2-size-drawer]');
      const sizeDrawerPanel = sizeDrawerEl ? sizeDrawerEl.querySelector('.mp2-size-drawer__panel') : null;
      let sizeDrawerPrevFocus = null;

      const openSizeDrawer = (productId) => {
        if (!sizeDrawerEl || !productId) return;
        sizeDrawerPrevFocus = document.activeElement;
        sizeDrawerEl.querySelectorAll('[data-mp2-size-product]').forEach((slide) => {
          slide.hidden = slide.getAttribute('data-mp2-size-product') !== String(productId);
        });
        sizeDrawerEl.hidden = false;
        sizeDrawerEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => sizeDrawerEl.setAttribute('data-mp2-size-drawer-open', ''));
        document.body.classList.add('mp2-size-drawer-open');
        if (sizeDrawerPanel) setTimeout(() => sizeDrawerPanel.focus({ preventScroll: true }), 360);
      };
      const closeSizeDrawer = () => {
        if (!sizeDrawerEl) return;
        sizeDrawerEl.removeAttribute('data-mp2-size-drawer-open');
        sizeDrawerEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mp2-size-drawer-open');
        setTimeout(() => { sizeDrawerEl.hidden = true; }, 360);
        if (sizeDrawerPrevFocus && typeof sizeDrawerPrevFocus.focus === 'function') sizeDrawerPrevFocus.focus({ preventScroll: true });
      };

      root.querySelectorAll('[data-mp2-upsell-size-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openSizeDrawer(btn.getAttribute('data-mp2-upsell-size-open'));
        });
      });
      if (sizeDrawerEl) {
        sizeDrawerEl.querySelectorAll('[data-mp2-size-drawer-close]').forEach((el) => el.addEventListener('click', closeSizeDrawer));
        sizeDrawerEl.querySelectorAll('[data-mp2-size-add]').forEach((btn) => {
          btn.addEventListener('click', async (e) => {
            e.preventDefault();
            if (btn.disabled) return;
            const vid = btn.getAttribute('data-mp2-size-add');
            closeSizeDrawer();
            await ajaxAdd(vid);
          });
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && sizeDrawerEl.hasAttribute('data-mp2-size-drawer-open')) closeSizeDrawer();
        });
      }
    });

    // Reassurance ETA — fills "Pide hoy y recíbelo entre [from] - [to]"
    // with computed dates based on today + min/max delivery days.
    // Past the cutoff hour the window shifts +1 day. Weekends optional.
    document.querySelectorAll('[data-mp2-reass-eta]').forEach((el) => {
      if (el.dataset.etaInit) return;
      el.dataset.etaInit = '1';
      const tmpl = el.dataset.template || el.textContent || '';
      const min = parseInt(el.dataset.minDays, 10) || 2;
      const max = parseInt(el.dataset.maxDays, 10) || 5;
      const cutoff = parseInt(el.dataset.cutoff, 10) || 0;
      const skipWk = el.dataset.skipWeekends === '1';
      const now = new Date();
      let extra = 0;
      if (cutoff > 0 && now.getHours() >= cutoff) extra = 1;
      const shift = (d) => {
        if (!skipWk) return d;
        const day = d.getDay();
        if (day === 0) d.setDate(d.getDate() + 1);
        else if (day === 6) d.setDate(d.getDate() + 2);
        return d;
      };
      const from = new Date(now); from.setDate(from.getDate() + min + extra); shift(from);
      const to   = new Date(now); to.setDate(to.getDate() + max + extra);   shift(to);
      const lang = (document.documentElement.lang || 'es').slice(0, 2);
      const fmt = (d) => {
        try { return d.toLocaleDateString(lang, { day: 'numeric', month: 'short' }); }
        catch (e) { return d.toDateString(); }
      };
      el.textContent = tmpl
        .replace('%from%', fmt(from))
        .replace('%to%', fmt(to));
    });
  })();

  // Force story-thumb video autoplay (same pattern as shop-the-look).
  // Browsers ignore the autoplay attribute on iOS / low-power / data-saver mode;
  // mute+playsInline at runtime, retry on rejection, play/pause via IO.
  (function () {
    function initStoryVideos(root) {
      const videos = (root || document).querySelectorAll('.mp2__story-video');
      if (!videos.length) return;
      const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => { v.muted = true; v.play().catch(() => {}); });
        }
      };
      videos.forEach((v) => {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        if (v.readyState >= 2) tryPlay(v);
        else v.addEventListener('loadeddata', () => tryPlay(v), { once: true });
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) tryPlay(v);
              else if (!v.paused) v.pause();
            });
          }, { threshold: 0.1 });
          io.observe(v);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', () => initStoryVideos(document));
    document.addEventListener('shopify:section:load', (e) => initStoryVideos(e.target));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) initStoryVideos(document); });
    window.addEventListener('pageshow', () => initStoryVideos(document));
  })();

  // Mobile sheet-overlay — darkens the sticky gallery progressively
  // as the info column rises over it. Mirrors the moea / hover-theme
  // pattern (--sheet-overlay-opacity inline-style). Active only on
  // mobile because desktop uses a side-by-side grid, no overlap.
  (function () {
    const mq = window.matchMedia('(max-width: 1023px)');
    document.querySelectorAll('.mp2').forEach((root) => {
      const gallery = root.querySelector('.mp2__gallery');
      const info    = root.querySelector('.mp2__info');
      if (!gallery || !info) return;

      let rafId = null;
      const update = () => {
        rafId = null;
        if (!mq.matches) {
          gallery.style.removeProperty('--mp2-overlay');
          return;
        }
        const g = gallery.getBoundingClientRect();
        const i = info.getBoundingClientRect();
        // overlap = how much the info column has risen INTO the
        // gallery's vertical band. Clamp 0..gallery height.
        const overlap = Math.max(0, g.bottom - i.top);
        const span    = Math.max(1, g.height);
        const progress = Math.min(1, overlap / span);
        // Cap at 0.45 — full black is too aggressive while reading.
        gallery.style.setProperty('--mp2-overlay', (progress * 0.45).toFixed(3));
      };
      const tick = () => { if (rafId == null) rafId = requestAnimationFrame(update); };

      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      mq.addEventListener && mq.addEventListener('change', tick);
      update();
    });
  })();

  // Gallery zoom modal — clicks on .mp2__zoom open a fullscreen <dialog> with
  // the currently-active gallery media (image or video) cloned inside.
  (function () {
    document.querySelectorAll('.mp2').forEach((root) => {
      const trigger = root.querySelector('[data-mp2-zoom]');
      const modal   = root.querySelector('[data-mp2-zoom-modal]');
      const inner   = root.querySelector('[data-mp2-zoom-inner]');
      const closeBtn = root.querySelector('[data-mp2-zoom-close]');
      if (!trigger || !modal || !inner) return;

      const openZoom = () => {
        const activeDot = root.querySelector('.mp2__dot.is-active');
        const idx = activeDot ? activeDot.getAttribute('data-mp2-dot') : '0';
        const media = root.querySelector('[data-mp2-media="' + idx + '"]');
        const src = media && (media.querySelector('img, video'));
        inner.innerHTML = '';
        if (src) {
          const clone = src.cloneNode(true);
          if (clone.tagName === 'IMG') {
            clone.removeAttribute('loading');
            clone.removeAttribute('sizes');
          } else if (clone.tagName === 'VIDEO') {
            clone.muted = true; clone.autoplay = true; clone.loop = true; clone.playsInline = true;
            clone.controls = true;
          }
          inner.appendChild(clone);
        }
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
      };
      const closeZoom = () => {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
        inner.innerHTML = '';
        document.documentElement.style.overflow = '';
      };

      trigger.addEventListener('click', openZoom);
      if (closeBtn) closeBtn.addEventListener('click', closeZoom);
      // Click on backdrop area (outside the inner content) closes too
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeZoom();
      });
      modal.addEventListener('cancel', closeZoom);
    });
  })();

  // Accordion: independent items (multiple can be open). Clicking one expands
  // it downward; items above keep their position. The first one is open by
  // default server-side.

  // Klaviyo BIS — disparo manual desde los "Avísame" custom del popover.
// La detección automática de Klaviyo no ve estos botones porque viven
// dentro de un popover oculto que se renderiza después del page load.
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.klaviyo-bis-trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = trigger.getAttribute('data-variant-id');
    if (variantId && window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm({ variantId: String(variantId) });
    }
  }, true); // useCapture: true → corre ANTES que el handler de fila
})();
// === Klaviyo Back-in-Stock vía Client API (tema custom) ===
// El editor visual de Klaviyo no detecta nuestros botones (popover
// custom), así que abrimos un popup propio y enviamos la suscripción
// directamente al endpoint client/back-in-stock-subscriptions.
(function () {
  var KLAVIYO_PUBLIC_API_KEY = 'TTJXRR'; // ← tu Site ID (6 caracteres)
  var KLAVIYO_REVISION = '2024-10-15'; // si Klaviyo da error de revision, prueba otra fecha de su doc

  var bis = document.querySelector('[data-mp2-bis]');
  if (!bis) return;
  var panel    = bis.querySelector('.mp2-bis__panel');
  var sizeEl   = bis.querySelector('[data-mp2-bis-size]');
  var emailEl  = bis.querySelector('[data-mp2-bis-email]');
  var submitEl = bis.querySelector('[data-mp2-bis-submit]');
  var msgEl    = bis.querySelector('[data-mp2-bis-msg]');
  var currentVariantId = null;
  var prevFocus = null;

  function showMsg(text, type) {
    msgEl.textContent = text;
    msgEl.className = 'mp2-bis__msg ' + (type === 'ok' ? 'mp2-bis__msg--ok' : 'mp2-bis__msg--err');
    msgEl.hidden = false;
  }
  function clearMsg() { msgEl.hidden = true; msgEl.textContent = ''; }

  function openBis(variantId, sizeLabel) {
    currentVariantId = variantId;
    if (sizeEl) sizeEl.textContent = sizeLabel || '';
    clearMsg();
    if (emailEl) emailEl.value = '';
    if (submitEl) submitEl.disabled = false;
    prevFocus = document.activeElement;
    bis.hidden = false;
    bis.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { bis.setAttribute('data-mp2-bis-open', ''); });
    document.body.classList.add('mp2-bis-open');
    setTimeout(function () { if (emailEl) emailEl.focus(); }, 200);
  }
  function closeBis() {
    bis.removeAttribute('data-mp2-bis-open');
    bis.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mp2-bis-open');
    setTimeout(function () { bis.hidden = true; }, 260);
    if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus({ preventScroll: true });
  }

  // Interceptar los "Avísame" en fase de captura (antes que el handler de fila)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.klaviyo-bis-trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = trigger.getAttribute('data-variant-id') ||
                    (trigger.getAttribute('href') || '').replace('#notify-', '').trim();
    // Etiqueta de talla, si la fila la tiene
    var row = trigger.closest('.mp2__size-row');
    var label = row && row.querySelector('.mp2__size-label');
    openBis(variantId, label ? label.textContent.trim() : '');
  }, true);

  // Cerrar
  bis.querySelectorAll('[data-mp2-bis-close]').forEach(function (el) {
    el.addEventListener('click', closeBis);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && bis.hasAttribute('data-mp2-bis-open')) closeBis();
  });

  // Enviar suscripción a Klaviyo
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  async function subscribe() {
    var email = (emailEl.value || '').trim();
    if (!validEmail(email)) { showMsg('Introduce un email válido.', 'err'); return; }
    if (!currentVariantId) { showMsg('No se pudo identificar la talla.', 'err'); return; }
    submitEl.disabled = true;
    clearMsg();
    try {
      var res = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_API_KEY, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': KLAVIYO_REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + currentVariantId
                }
              }
            }
          }
        })
      });
      if (res.ok || res.status === 202) {
        showMsg('¡Listo! Te avisaremos por email cuando vuelva el stock.', 'ok');
        submitEl.disabled = true;
        setTimeout(closeBis, 2200);
      } else {
        var errTxt = await res.text().catch(function () { return ''; });
        console.error('[Klaviyo BIS] error', res.status, errTxt);
        showMsg('No se pudo completar la suscripción. Inténtalo de nuevo.', 'err');
        submitEl.disabled = false;
      }
    } catch (err) {
      console.error('[Klaviyo BIS] fetch error', err);
      showMsg('Error de conexión. Inténtalo de nuevo.', 'err');
      submitEl.disabled = false;
    }
  }

  if (submitEl) submitEl.addEventListener('click', subscribe);
  if (emailEl) emailEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); subscribe(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.main-product').forEach((root) => {
      const form = root.querySelector('[data-mp-form]');
      if (!form) return;
      const variantInput = form.querySelector('[data-mp-variant-id]');
      const cta = root.querySelector('[data-mp-cta]');
      const popover = root.querySelector('[data-mp-size-dialog]');
      const closeBtn = root.querySelector('[data-mp-close-size]');
      const sizeBtns = root.querySelectorAll('[data-mp-size]');
      const colorBtns = root.querySelectorAll('[data-mp-color]');
      const colorLabel = root.querySelector('[data-mp-color-label]');

      colorBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          colorBtns.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (colorLabel) colorLabel.textContent = btn.getAttribute('data-mp-color');
        });
      });

      function openPopover() { if (popover) popover.hidden = false; }
      function closePopover() { if (popover) popover.hidden = true; }

      async function ajaxAddToCart() {
        try {
          const fd = new FormData(form);
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'add to cart failed');
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const drawerOpen = document.querySelector('[data-cart-drawer-open]');
          if (drawerOpen) drawerOpen.click(); else window.location = '/cart';
        } catch (err) {
          console.error(err);
          form.submit();
        }
      }

      if (cta) {
        cta.addEventListener('click', async (e) => {
          e.preventDefault();
          if (popover) {
            if (popover.hidden) openPopover(); else closePopover();
          } else {
            await ajaxAddToCart();
          }
        });
      }

      if (closeBtn) closeBtn.addEventListener('click', closePopover);

      // Click outside popover closes it
      document.addEventListener('click', (e) => {
        if (!popover || popover.hidden) return;
        if (popover.contains(e.target) || (cta && cta.contains(e.target))) return;
        closePopover();
      });

      sizeBtns.forEach((btn) => {
        btn.addEventListener('click', async () => {
          if (btn.disabled) return;
          const vid = btn.getAttribute('data-mp-variant');
          if (vid && variantInput) variantInput.value = vid;
          closePopover();
          await ajaxAddToCart();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.material-selector').forEach((sec) => {
      const triggers = sec.querySelectorAll('[data-ms-tab]');
      const mobileLabels = sec.querySelectorAll('[data-ms-mobile-tab]');
      const panels = sec.querySelectorAll('[data-ms-panel]');

      const mobilePanels = sec.querySelectorAll('[data-ms-mobile-panel]');

      const setActive = (idx) => {
        triggers.forEach((x) => {
          const match = x.dataset.msTab === idx;
          x.classList.toggle('is-active', match);
          x.setAttribute('aria-selected', match);
        });
        mobileLabels.forEach((x) => x.classList.toggle('is-active', x.dataset.msMobileTab === idx));
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.msPanel === idx));
        mobilePanels.forEach((p) => p.classList.toggle('is-active', p.dataset.msMobilePanel === idx));
      };

      triggers.forEach((t) => t.addEventListener('click', () => setActive(t.dataset.msTab)));
      mobileLabels.forEach((t) => t.addEventListener('click', () => {
        setActive(t.dataset.msMobileTab);
        t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }));

      // Desktop panel sliders (prev/next arrows)
      sec.querySelectorAll('[data-ms-prev]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const track = sec.querySelector('[data-ms-track="' + btn.dataset.msPrev + '"]');
          if (!track) return;
          const slide = track.querySelector('.product-card');
          const step = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
          track.scrollBy({ left: -step, behavior: 'smooth' });
        });
      });
      sec.querySelectorAll('[data-ms-next]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const track = sec.querySelector('[data-ms-track="' + btn.dataset.msNext + '"]');
          if (!track) return;
          const slide = track.querySelector('.product-card');
          const step = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
          track.scrollBy({ left: step, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nav-drawer]').forEach((drawer) => {
      if (drawer.dataset.ndInit) return;
      drawer.dataset.ndInit = '1';

      // Velocidad: el contenido del cajón no se pinta (ni descarga sus
      // imágenes) hasta la primera apertura o unos segundos después de load.
      const warm = () => { drawer.dataset.ndOpened = '1'; };
      if (document.readyState === 'complete') setTimeout(warm, 4000);
      else window.addEventListener('load', () => setTimeout(warm, 4000), { once: true });
      const open = () => {
        warm();
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };
      const close = () => {
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      // Global open triggers (header burger, etc.)
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest && e.target.closest('[data-nav-drawer-open]');
        if (trigger) { e.preventDefault(); open(); }
      });

      // Close + tab switching (scoped to this drawer)
      drawer.addEventListener('click', (e) => {
        if (e.target.closest('[data-nd-close]')) {
          e.preventDefault();
          close();
          return;
        }

        const tab = e.target.closest('[data-nd-tab]');
        if (tab) {
          e.preventDefault();
          // If the tab is ALREADY active and has a home_url, the click
          // navigates there (the second tap on the same tab takes you to
          // the gender's home). First/non-active click just switches
          // panels as usual. Simpler and more discoverable than a strict
          // double-click timer.
          const homeUrl = tab.getAttribute('data-nd-tab-home');
          if (homeUrl && tab.classList.contains('is-active')) {
            window.location.href = homeUrl;
            return;
          }

          const key = tab.getAttribute('data-nd-tab');
          drawer.querySelectorAll('[data-nd-tab]').forEach((b) => {
            const active = b === tab;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          drawer.querySelectorAll('[data-nd-tabpanel]').forEach((p) => {
            p.classList.toggle('is-active', p.getAttribute('data-nd-tabpanel') === key);
          });
          // Reset scroll on tab change so each panel starts at top
          const body = drawer.querySelector('.nd__body');
          if (body) body.scrollTop = 0;
          return;
        }

        // Expand/collapse — parent links with children show a + button that
        // toggles the sublinks (bubbles) list below. The whole .nd__link-row
        // is also a toggle target (anchor included) so users can tap the row
        // anywhere instead of hunting for the small + icon. The anchor's
        // default navigation is preempted only when the row is expandable.
        const expandBtn = e.target.closest('[data-nd-expand]');
        const rowEl     = e.target.closest('.nd__link-row');
        const expLi     = (expandBtn || rowEl) && (expandBtn || rowEl).closest('[data-nd-expandable]');
        if (expLi) {
          e.preventDefault();
          const btn = expLi.querySelector('[data-nd-expand]');
          const sub = expLi.querySelector('.nd__sublinks');
          if (!btn || !sub) return;
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          sub.hidden = expanded;
          return;
        }

        // Sub-tab switching — scoped to the .nd__subtabs-wrap so each panel's
        // sub-tabs are independent. Keys are blockId-index.
        const sub = e.target.closest('[data-nd-subtab]');
        if (sub) {
          e.preventDefault();
          const subKey = sub.getAttribute('data-nd-subtab');
          const wrap = sub.closest('.nd__subtabs-wrap');
          if (!wrap) return;
          wrap.querySelectorAll('[data-nd-subtab]').forEach((b) => {
            const active = b === sub;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          wrap.querySelectorAll('[data-nd-subpanel]').forEach((p) => {
            p.classList.toggle('is-active', p.getAttribute('data-nd-subpanel') === subKey);
          });
          return;
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pdp-accordion').forEach((root) => {
      const rows = root.querySelectorAll('.pdp-accordion__row');

      // Mobile: collapse any rows that Liquid rendered as `open` so
      // every accordion starts closed on mobile. Desktop keeps the
      // open_by_default behavior. matchMedia mirrors the rest of the
      // mp2 mobile breakpoint (≤1023px).
      if (matchMedia('(max-width: 1023px)').matches) {
        rows.forEach((row) => { if (row.open) row.removeAttribute('open'); });
      }

      rows.forEach((row) => {
        row.addEventListener('toggle', () => {
          if (!row.open) return;
          rows.forEach((other) => { if (other !== row && other.open) other.open = false; });
        });
      });

      // Scroll-reveal --p driver. Monotonic 0 → 1 (no closing loop).
      // The active opening window covers a generous 0.30–0.85 of the
      // section's travel across the viewport (~55% of total scroll),
      // so the layers open SLOWLY. After 0.85 they stay fully apart
      // until the section exits. easeOutCubic shapes the ramp so
      // the start is gentle and it settles smoothly at the top.
      const ACTIVE_START = 0.37;
      const ACTIVE_END   = 0.90;
      const ACTIVE_SPAN  = ACTIVE_END - ACTIVE_START;
      const mq = window.matchMedia('(min-width: 1024px)');
      let ticking = false;
      const update = () => {
        if (!mq.matches) { root.style.setProperty('--p', '0'); ticking = false; return; }
        const rect = root.getBoundingClientRect();
        const sectionH = root.offsetHeight;
        const vh = window.innerHeight;
        const total = vh + sectionH;
        const distance = vh - rect.top;
        const progress = Math.min(1, Math.max(0, distance / total));
        const remapped = Math.min(1, Math.max(0, (progress - ACTIVE_START) / ACTIVE_SPAN));
        const p = 1 - Math.pow(1 - remapped, 3); // easeOutCubic
        root.style.setProperty('--p', p.toFixed(4));
        ticking = false;
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-row]').forEach((row) => {
      const tabs = row.querySelectorAll('[data-row-tab]');
      const panels = row.querySelectorAll('[data-row-panel]');
      const isSlider = row.dataset.mode === 'slider';
      const sliderRenders = new Map();

      // ---- Tab switching ----
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.rowTab;
          const targetPanel = row.querySelector('[data-row-panel="' + target + '"]');
          const tpl = targetPanel && targetPanel.querySelector('template[data-row-lazy]');
          if (tpl) {
            targetPanel.appendChild(tpl.content);
            tpl.remove();
            if (isSlider) initPanel(targetPanel);
          }
          tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((p) => {
            const active = p.dataset.rowPanel === target;
            p.classList.toggle('is-active', active);
            if (active) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
          });
          // Re-render pagination for the now-visible panel (it had clientWidth=0 while hidden)
          const activePanel = row.querySelector('[data-row-panel]:not([hidden])');
          const render = activePanel && sliderRenders.get(activePanel);
          if (render) requestAnimationFrame(render);
        });
      });

      // ---- Slider behaviors (drag + pagination) per panel ----
      function initPanel(panel) {
        const track = panel.querySelector('[data-row-track]');
        const pagesHost = panel.querySelector('[data-row-pages]');
        if (!track) return;

        // ---- Pagination dots ----
        const getPages = () => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          if (max <= 1) return 1;
          return Math.ceil(max / track.clientWidth) + 1;
        };
        const getActive = () => {
          if (track.clientWidth === 0) return 0;
          return Math.round(track.scrollLeft / track.clientWidth);
        };
        const renderPages = () => {
          if (!pagesHost) return;
          const pages = getPages();
          if (pages <= 1) { pagesHost.innerHTML = ''; return; }
          const active = getActive();
          let html = '';
          for (let i = 0; i < pages; i++) {
            const isActive = i === active;
            html += '<button type="button" class="product-row__page" data-row-page="' + i + '"'
              + (isActive ? ' aria-current="true"' : '')
              + ' aria-label="Page ' + (i + 1) + '">' + (i + 1) + '</button>';
          }
          pagesHost.innerHTML = html;
        };
        sliderRenders.set(panel, renderPages);
        renderPages();
        window.addEventListener('resize', renderPages);
        track.addEventListener('scroll', () => {
          if (!pagesHost) return;
          const buttons = pagesHost.querySelectorAll('.product-row__page');
          const active = getActive();
          buttons.forEach((b, i) => {
            if (i === active) b.setAttribute('aria-current', 'true');
            else b.removeAttribute('aria-current');
          });
        }, { passive: true });
        if (pagesHost) {
          pagesHost.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-row-page]');
            if (!btn) return;
            const idx = parseInt(btn.dataset.rowPage, 10) || 0;
            track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
          });
        }

        // ---- Prev/next arrow buttons ----
        const navPrev = panel.querySelector('[data-row-prev]');
        const navNext = panel.querySelector('[data-row-next]');
        const cellStep = () => {
          const cell = track.querySelector('.product-row__cell');
          if (!cell) return track.clientWidth * 0.8;
          const cs = getComputedStyle(track);
          const gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
          return cell.getBoundingClientRect().width + gap;
        };
        const updateNav = () => {
          if (!navPrev && !navNext) return;
          const max = track.scrollWidth - track.clientWidth;
          if (navPrev) navPrev.toggleAttribute('disabled', track.scrollLeft <= 1);
          if (navNext) navNext.toggleAttribute('disabled', track.scrollLeft >= max - 1);
        };
        navPrev && navPrev.addEventListener('click', () => {
          track.scrollBy({ left: -cellStep(), behavior: 'smooth' });
        });
        navNext && navNext.addEventListener('click', () => {
          track.scrollBy({ left: cellStep(), behavior: 'smooth' });
        });
        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();

        // ---- Drag-to-scroll (desktop mouse only) ----
        let startX = 0, startLeft = 0, dragging = false, activePtr = null, suppressClick = false;
        const DRAG_THRESHOLD = 6;
        track.addEventListener('dragstart', (e) => e.preventDefault());

        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'touch') return;
          activePtr = e.pointerId;
          startX = e.clientX;
          startLeft = track.scrollLeft;
          dragging = false;
          suppressClick = false;
        });
        track.addEventListener('pointermove', (e) => {
          if (e.pointerId !== activePtr) return;
          const dx = e.clientX - startX;
          if (!dragging && Math.abs(dx) > DRAG_THRESHOLD) {
            dragging = true;
            row.classList.add('is-dragging');
            try { track.setPointerCapture(activePtr); } catch {}
          }
          if (dragging) {
            e.preventDefault();
            track.scrollLeft = startLeft - dx;
          }
        });
        const release = (e) => {
          if (e.pointerId !== activePtr) return;
          if (dragging) {
            try { track.releasePointerCapture(activePtr); } catch {}
            suppressClick = true;
            // Clear suppression after the synthetic click event
            setTimeout(() => { suppressClick = false; row.classList.remove('is-dragging'); }, 50);
          }
          dragging = false;
          activePtr = null;
        };
        track.addEventListener('pointerup', release);
        track.addEventListener('pointercancel', release);
        track.addEventListener('click', (e) => {
          if (suppressClick) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        // Touch handling: native overflow-x: auto scroll. No custom touch
        // listeners. Matches the `dore` branch pattern which works on real
        // iOS/Android. Key requirement: the .product-card__images wrapper
        // is collapsed via `display: contents` on mobile (see product-card
        // snippet) so the anchor sits as an effective direct child of
        // .product-card__media — short enough nesting for iOS arbitration
        // to promote pan-x cleanly to the row track.
      }
      if (isSlider) panels.forEach((panel) => initPanel(panel));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideos(root) {
      const videos = (root || document).querySelectorAll('.shop-the-look__video');
      if (!videos.length) return;
      const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {
            // Autoplay was blocked. Mute then retry once.
            v.muted = true;
            v.play().catch(() => {});
          });
        }
      };
      videos.forEach((v) => {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        // Force the browser to attempt to play. autoplay attribute alone is sometimes
        // ignored on iOS / when bandwidth-saver mode is on.
        if (v.readyState >= 2) tryPlay(v);
        else v.addEventListener('loadeddata', () => tryPlay(v), { once: true });
        // Re-play when entering viewport (handles lazy-rendered slides + bfcache restores)
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) tryPlay(v);
              else if (!v.paused) v.pause();
            });
          }, { threshold: 0.1 });
          io.observe(v);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', () => initVideos(document));
    document.addEventListener('shopify:section:load', (e) => initVideos(e.target));
    // Resume on visibility / pageshow (mobile bfcache)
    document.addEventListener('visibilitychange', () => { if (!document.hidden) initVideos(document); });
    window.addEventListener('pageshow', () => initVideos(document));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.trust-badges').forEach((sec) => {
      const track = sec.querySelector('[data-tb-track]');
      const dots = sec.querySelectorAll('[data-tb-dot]');
      if (!track || !dots.length) return;

      const slides = track.children;
      const update = () => {
        const w = track.clientWidth;
        if (!w) return;
        const idx = Math.round(track.scrollLeft / w);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      };
      track.addEventListener('scroll', () => {
        clearTimeout(track._tbT);
        track._tbT = setTimeout(update, 80);
      });
      dots.forEach((d, i) => d.addEventListener('click', () => {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultraheight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ultraheight]').forEach((sec) => {
      if (sec.dataset.uhInit) return;
      sec.dataset.uhInit = '1';

      // We flip a class on <html> rather than mutating each bar element
      // directly. That makes the hide rule trivially win over the
      // header's own state classes (is-hidden, is-sticky-scrolled,
      // is-transparent) since the CSS rule is qualified with `html.uh-active`.
      const root = document.documentElement;

      let ticking = false;
      const update = () => {
        // Progress = how far the section's top has scrolled past the viewport
        // top, divided by the available scroll distance (sectionH - vh).
        // Clamped 0..1. We read getBoundingClientRect each tick (cheap).
        const rect = sec.getBoundingClientRect();
        const sectionH = sec.offsetHeight;
        const vh = window.innerHeight;
        const scrolled = -rect.top;
        const total = Math.max(1, sectionH - vh);
        const p = Math.min(1, Math.max(0, scrolled / total));
        sec.style.setProperty('--p', p.toFixed(4));

        // Hide the site header AND the announcement bar while the
        // section is pinning — i.e. its top has reached/passed the
        // viewport top AND the section hasn't scrolled past completely.
        // Outside that window we let them behave normally.
        const inSection = rect.top <= 0 && rect.bottom > 0;
        root.classList.toggle('uh-active', inSection);

        ticking = false;
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      // Safety: when this section is removed (theme editor live reload,
      // navigation), drop the flag so the next page doesn't inherit
      // a hidden header / announcement bar.
      window.addEventListener('beforeunload', () => {
        root.classList.remove('uh-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
